import React, { Fragment, useState, useEffect, useContext } from "react";
import { appContext } from "../../../Utils/context";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import InputMask from "react-input-mask";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faTrashAlt,
  faPhone,
  faEnvelope,
  faMinusCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast, Slide } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import Portal from "../../../Utils/portals";
import records from "../../../Services/records";
import { DropdownList } from "react-widgets";
import {
  Input,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Spinner,
  Collapse,
  FormFeedback,
  FormGroup,
} from "reactstrap";

export default function OwnerDetail({ data, recordId, setData }) {
  const state1 = { uat_id: recordId, contact_type: "phones" };
  const state2 = { uat_id: recordId, contact_type: "emails" };
  const { addressId } = useContext(appContext);
  const [custom, setCustom] = useState(false);
  const [custom2, setCustom2] = useState(false);
  const [phone, setPhone] = useState([]);
  const [email, setEmail] = useState([]);
  const [deleteRequesting, setDeleteRequesting] = useState(false);
  const [emailData, setEmailData] = useState({
    uat_id: recordId,
    contact_type: "emails",
  });
  const [phoneData, setPhoneData] = useState({ ...state1 });
  const [alert1, setAlert1] = useState(false);
  const [alert2, setAlert2] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [specificPhone, setSpecificPhone] = useState(" ");
  const [specificEmail, setSpecificEmail] = useState(" ");
  const [emailValidate, setEmailValidate] = useState(" ");
  const [phoneValidate, setPhoneValidate] = useState(" ");
  const [attorCustom1, setAttorCustom1] = useState(false);
  const [attorCustom2, setAttorCustom2] = useState(false);
  const [petitCustom1, setPetitCustom1] = useState(false);
  const [petitCustom2, setPetitCustom2] = useState(false);
  const [phoneRequesting, setPhoneRequesting] = useState(false);
  const [emailRequesting, setEmailRequesting] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [searchWord, setSearchWord] = useState(null);
  const [busy, setBusy] = useState(false);
  const [btn, setBtn] = useState("Add");

  // const handleCollase = (id) => {

  //   setOpen((prevState) => ({ ...prevState, [id]: !prevState[id] }));
  // }

  const handleChange1 = (v, k) => {
    setEmailData({ ...emailData, [k]: v });
    if (v === "") {
      setEmailValidate("");
      //setEmailData("")
    } else {
      if (k === "email") {
        var errors = formEmailValidation(v);
        setEmailValidate(errors);
      }
    }
  };
  const handleChange2 = (v, k) => {
    setPhoneData({ ...phoneData, [k]: v });
    if (v === "") {
      setPhoneValidate("");
      //setPhoneData("")
    } else {
      if (k === "phone_number") {
        var errors = formPhoneValidation(v);
        setPhoneValidate(errors);
      }
    }
  };

  useEffect(() => {
    if (recordId !== undefined) {
      let isMounted = true;
      records
        .contactInfo(state1)
        .then((res) => {
          if (isMounted) {
            setPhone(res.data?.phones);
          }
        })
        .catch((err) => {
          console.log("error:", err);
        });
      return () => {
        isMounted = false;
      };
    }
  }, []);

  useEffect(() => {
    if (recordId !== undefined) {
      let isMounted = true;
      records
        .contactInfo(state2)
        .then((res) => {
          if (isMounted) {
            setEmail(res.data?.emails);
          }
        })
        .catch((err) => {
          console.log("error:", err);
        });
      return () => {
        isMounted = false;
      };
    }
  }, []);

  const formEmailValidation = (email) => {
    let errors = {};
    const emailRex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/;
    if (!email) {
      errors.email = "Email is required";
      errors.hasErrors = true;
      errors.validate = "has-danger";
    } else if (!emailRex.test(email)) {
      errors.email = "Email is invalid";
      errors.hasErrors = true;
      errors.validate = "has-danger";
    } else {
      errors.email = "Email is valid";
      errors.hasErrors = false;
      errors.validate = "has-success";
    }
    return errors;
  };

  const addUpdateEmail = () => {
    const errors = formEmailValidation(emailData.email);
    setEmailValidate(errors);

    if (errors.hasErrors) {
      return;
    }

    setEmailRequesting(true);

    const apiCall =
      btn === "Add"
        ? records.addContactInfo(emailData)
        : records.updateContactInfo({
            uat_id: emailData.uat_id,
            contact_type: emailData.contact_type,
            new_email: emailData.email,
            old_email: emailData.old_email,
          });

    apiCall
      .then((res) => {
        emailData.email = " ";
        setEmail(res.data?.emails);
        const message = btn === "Add" ? "Email Added" : "Email Updated";
        notify22(message, "success");
        setEmailValidate("");
        setCustom2(!custom2);
      })
      .catch((err) => {
        console.log("error is", err);
        notify22(err.response?.data?.message, "error");
      })
      .finally(() => setEmailRequesting(false));
  };

  const emailValueCancel = () => {
    setCustom2(!custom2);
    setEmailData({ ...state2 });
    setEmailValidate("");
    setBtn("Add");
  };
  const formPhoneValidation = (phoneData) => {
    let errors = {};
    var phoneRex = RegExp(/\(\d{3}\) \d{3}-\d{4}/);
    if (!phoneData) {
      errors.phone_number = "Phone Number is required";
      errors.hasErrors = true;
      errors.validate = "has-danger";
    } else if (!phoneRex.test(phoneData)) {
      errors.phone_number = "Phone Number is invalid";
      errors.hasErrors = true;
      errors.validate = "has-danger";
    } else {
      errors.phone_number = "Phone Number is valid";
      errors.hasErrors = false;
      errors.validate = "has-success";
    }
    return errors;
  };

  const addUpdatePhone = () => {
    const errors = formPhoneValidation(phoneData.phone_number);
    setPhoneValidate(errors);

    if (errors.hasErrors) {
      return;
    }

    setPhoneRequesting(true);

    const apiCall =
      btn === "Add"
        ? records.addContactInfo(phoneData)
        : records.updateContactInfo({
            uat_id: phoneData.uat_id,
            contact_type: phoneData.contact_type,
            new_phone_no: phoneData.phone_number,
            phone_no: phoneData.old_phone_no,
            phone_type: phoneData.phone_type,
            phone_status: phoneData.phone_status,
          });
    apiCall
      .then((res) => {
        phoneData.phone_number = " ";
        phoneData.phone_type = " ";
        setPhone(res.data?.phones);
        const message =
          btn === "Add" ? "Phone Number Added" : "Phone Number Updated";
        notify22(message, "success");
        setPhoneValidate("");
        setCustom(!custom);
      })
      .catch((err) => {
        console.log("error is", err);
        notify22(err.response?.data?.message, "error");
      })
      .finally(() => setPhoneRequesting(false));
  };

  // const addPhone = () => {
  //   var errors = formPhoneValidation(phoneData.phone_number);
  //   setPhoneValidate(errors);
  //   if (!errors.hasErrors) {
  //     setPhoneRequesting(true)

  //     if (btn === 'Add') {
  //       records
  //         .addContactInfo(phoneData)
  //         .then((res) => {
  //           phoneData.phone_number = " ";
  //           phoneData.phone_type = " ";
  //           setPhone(res.data?.phones);

  //           notify22("Phone Number Added", "success");
  //           setPhoneValidate("");
  //           setCustom(!custom)
  //         })
  //         .catch((err) => {
  //           console.log("error is", err);
  //           notify22(err.response?.data?.message, "error");
  //         }).finally(() => setPhoneRequesting(false))
  //     }
  //     else {
  //       records
  //         .updateContactInfo({
  //           uat_id: phoneData?.uat_id, contact_type: phoneData?.contact_type, new_phone_no: phoneData?.phone_number,
  //           old_phone_no: phoneData?.old_phone_no
  //         })
  //         .then((res) => {
  //           phoneData.phone_number = " ";
  //           phoneData.phone_type = " ";
  //           setPhone(res.data?.phones);

  //           notify22("Phone Number Updated", "success");
  //           setPhoneValidate("");
  //           setCustom(!custom)

  //         })
  //         .catch((err) => {
  //           console.log("error is", err);
  //           notify22(err.response?.data?.message, "error");
  //         }).finally(() => setPhoneRequesting(false))
  //     }
  //   }
  // };

  const phoneValueCancel = () => {
    setCustom(!custom);
    setPhoneValidate("");
    setPhoneData({ ...state1 });
    setBtn("Add");

    // setPhoneData("");
    // const clearphone = document.getElementById("phone_no");
    // clearphone.value = "";
  };

  const deletePhone = () => {
    setDeleteRequesting(true);
    records
      .deleteContactInfo({
        uat_id: recordId,
        contact_type: "phones",
        phone_number: specificPhone,
      })
      .then((res) => {
        setAlert1(false);
        setPhone(res.data?.phones);
        notify22("Phone Deleted", "success");
      })
      .catch((err) => {
        console.log("error is", err);
        setDeleteRequesting(false);
      })
      .finally(() => setDeleteRequesting(false));
  };
  const updateEmail = () => {
    //console.log("Email updated", specificEmail)
  };

  const deleteEmail = () => {
    setDeleteRequesting(true);
    records
      .deleteContactInfo({
        uat_id: recordId,
        contact_type: "emails",
        email: specificEmail,
      })
      .then((res) => {
        setAlert2(false);
        setEmail(res.data?.emails);
        notify22("Email Deleted", "success");
      })
      .catch((err) => {
        console.log("error is", err);
        setDeleteRequesting(false);
      })
      .finally(() => setDeleteRequesting(false));
  };

  const notify22 = (msg, type) =>
    toast(msg, {
      transition: Slide,
      autoClose: 5000,
      position: "top-right",
      type: type,
    });

  const renderColor = ({ item }) => (
    <>
      <span
        style={{
          width: 18,
          height: 18,
          marginRight: 8,
          display: "inline-block",
          verticalAlign: "text-bottom",
          backgroundColor: item.toLowerCase(),
        }}
      />
      {item}
    </>
  );

  const customRenderValue = (value) => {
    switch (value?.item) {
      case "Red":
        return (
          <span className="bg-danger rounded-pill text-white p-5">
            {value?.item}
          </span>
        );
      case "Yellow":
        return (
          <span className="bg-warning rounded-pill text-white p-5">
            {value?.item}
          </span>
        );
      case "Blue":
        return (
          <span className="bg-primary rounded-pill  text-white p-5">
            {value?.item}
          </span>
        );
      case "Orange":
        return (
          <span className="bg-success rounded-pill text-white p-5">
            {value?.item}
          </span>
        );
      default:
        return value;
    }
  };

  const searchCustomer = (val) => {
    // console.log("val is", val)
    setBusy(true);
    records
      .searchEmail({ email_open_word: val })
      .then((res) => {
        setSearchData(res?.data);
      })
      .catch((err) => console.log("error is", err))
      .finally(() => setBusy(false));

    if (val === "") {
      //console.log("Val", val)
      setSearchWord(null);
    }
  };

  const handlePerson = (k, v, index) => {
    const [mainKey, subKey] = k.split("."); // Split the key into main key and sub key

    setData({
      ...data,
      people: data.people.map((person, i) => {
        if (i === index) {
          if (subKey) {
            return {
              ...person,
              [mainKey]: [
                {
                  ...person[mainKey][0],
                  [subKey]: v,
                },
              ],
            };
          } else {
            return {
              ...person,
              [k]: v,
            };
          }
        }
        return person;
      }),
    });
  };

  const addPeople = () => {
    setData({
      ...data,
      people: [
        ...data.people,
        {
          title: "",
          age: "",
          first_name: "",
          last_name: "",
          middle_name: "",
          suffix: "",
          addresses: [
            {
              zip: "",
              city: "",
              state: "",
              address1: "",
            },
          ],
        },
      ],
    });
  };

  const removePeople = (index) => {
    setData({
      ...data,
      people: data.people.filter((_, i) => i !== index),
    });
  };

  return (
    <Fragment>
      <TransitionGroup>
        <CSSTransition
          component="div"
          classNames="TabsAnimation"
          appear={true}
          timeout={0}
          enter={false}
          exit={false}
        >
          <div>
            <Row>
              <Col md="12">
                {data?.uat_id ? (
                  <>
                    {data?.lead_info?.frst && (
                      <Col md="12">
                        <Card className="main-card mb-2">
                          <CardBody>
                            <CardTitle>
                              <Row>
                                <Col xs="10">
                                  <legend>FirstUp</legend>
                                </Col>
                                <Col xs="2">
                                  <Button
                                    className="m-0 p-0"
                                    color="link"
                                    onClick={() => setCollapse(!collapse)}
                                  >
                                    {collapse === false ? "Expand" : "Collapse"}
                                  </Button>
                                </Col>
                              </Row>
                            </CardTitle>
                            <Collapse isOpen={collapse}>
                              <Row>
                                <Col md="12">
                                  {data?.lead_info?.frst?.people &&
                                    Object.keys(data?.lead_info?.frst?.people)
                                      .filter(
                                        (key) =>
                                          data?.lead_info?.frst?.people[key]
                                            ?.title !== "Relatives"
                                      )
                                      .map((key, index) => {
                                        const person =
                                          data?.lead_info?.frst?.people[key];
                                        return (
                                          <Card
                                            key={index}
                                            className="main-card mb-1"
                                          >
                                            <CardBody>
                                              <CardTitle></CardTitle>

                                              <Row>
                                                <Col
                                                  md="5"
                                                  className="text-center"
                                                >
                                                  <Row className="g-0">
                                                    <Col md="12">
                                                      <h4 className="text-primary m-0 text-center">
                                                        {person?.title}
                                                      </h4>
                                                    </Col>
                                                    <Col md="12">
                                                      <h3
                                                        style={{
                                                          color: "#003333",
                                                        }}
                                                      >
                                                        {person?.full_name ||
                                                          " "}{" "}
                                                      </h3>
                                                    </Col>
                                                    <Col md="12">
                                                      {Object.keys(
                                                        person?.addresses
                                                      ).map((k, index) => {
                                                        const address =
                                                          person?.addresses[
                                                            key
                                                          ];
                                                        return (
                                                          <p key={index}>
                                                            {address?.address1 ||
                                                              ""}
                                                            <br />{" "}
                                                            {address?.city},{" "}
                                                            {address?.state}{" "}
                                                            {address?.zip}
                                                          </p>
                                                        );
                                                      })}
                                                    </Col>
                                                    <Col md="6">
                                                      <p>
                                                        <b>AGE:</b>{" "}
                                                        {person?.age || "-"}
                                                      </p>
                                                    </Col>
                                                    <Col md="6">
                                                      {" "}
                                                      <p>
                                                        <b>Gender:</b>{" "}
                                                        {person?.gender || "-"}
                                                      </p>
                                                    </Col>
                                                    <Col md="12">
                                                      <p>
                                                        <b>Birth:</b>{" "}
                                                        {person?.dob || "-"}
                                                      </p>
                                                      <p>
                                                        <b>Death:</b>{" "}
                                                        {person?.dod || "-"}
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                </Col>
                                                <Col md="7">
                                                  <Row>
                                                    <Col xs="10" md="9">
                                                      <h5 className="fw-bold">
                                                        Phone Numbers
                                                      </h5>{" "}
                                                    </Col>
                                                    <Col xs="2" md="3"></Col>
                                                  </Row>
                                                  <Row className="g-0">
                                                    {person?.phones?.map(
                                                      (ph, k) => (
                                                        <Col
                                                          xs="6"
                                                          className="mb-1"
                                                          key={k}
                                                        >
                                                          {ph.phone}
                                                          <Button
                                                            className="border-0 btn-transition"
                                                            outline
                                                            color="success"
                                                            onClick={() =>
                                                              (window.location.href = `tel:${ph?.phone}`)
                                                            }
                                                          >
                                                            <FontAwesomeIcon
                                                              icon={faPhone}
                                                              size="1x"
                                                            />
                                                          </Button>
                                                        </Col>
                                                      )
                                                    )}
                                                  </Row>

                                                  <Row>
                                                    <Col xs="10">
                                                      <h5 className="fw-bold mt-3">
                                                        Emails{" "}
                                                      </h5>
                                                    </Col>
                                                    <Col xs="2"></Col>
                                                  </Row>

                                                  {person?.emails?.map(
                                                    (e, k) => (
                                                      <Row
                                                        className="g-0"
                                                        key={k}
                                                      >
                                                        <Col
                                                          xs="10"
                                                          className="mb-1"
                                                        >
                                                          {e?.email}
                                                        </Col>
                                                        <Col xs="2">
                                                          <Button
                                                            className="border-0 btn-transition"
                                                            outline
                                                            color="info"
                                                            title=" Mail"
                                                            onClick={() =>
                                                              window.open(
                                                                `mailto:${e?.email}`
                                                              )
                                                            }
                                                          >
                                                            <FontAwesomeIcon
                                                              icon={faEnvelope}
                                                              size="1x"
                                                            />
                                                          </Button>
                                                        </Col>
                                                      </Row>
                                                    )
                                                  )}
                                                </Col>
                                              </Row>
                                            </CardBody>
                                          </Card>
                                        );
                                      })}
                                </Col>
                              </Row>
                              {data?.lead_info?.frst?.people &&
                                Object.keys(
                                  data?.lead_info?.frst?.people
                                ).filter(
                                  (key) =>
                                    data?.lead_info?.frst?.people[key]
                                      ?.title === "Relatives"
                                ).length > 0 && (
                                  <Row>
                                    <Col md="12">
                                      <Card className="main-card mb-1">
                                        <CardBody>
                                          <CardTitle>Relatives</CardTitle>
                                          <Row>
                                            {data?.lead_info?.frst?.people &&
                                              Object.keys(
                                                data?.lead_info?.frst?.people
                                              )
                                                .filter(
                                                  (key) =>
                                                    data?.lead_info?.frst
                                                      ?.people[key]?.title ===
                                                    "Relatives"
                                                )
                                                .map((key, index) => {
                                                  const person =
                                                    data?.lead_info?.frst
                                                      ?.people[key];
                                                  // Render JSX for each person with title "Relatives"
                                                  return (
                                                    <Card className="main-card mb-1">
                                                      <CardBody>
                                                        <CardTitle></CardTitle>

                                                        <Row>
                                                          <Col
                                                            md="5"
                                                            className="text-center"
                                                          >
                                                            <Row className="g-0">
                                                              <Col md="12">
                                                                <h4 className="text-primary m-0 text-center">
                                                                  {
                                                                    person?.title
                                                                  }
                                                                </h4>
                                                              </Col>
                                                              <Col md="12">
                                                                <h3
                                                                  style={{
                                                                    color:
                                                                      "#003333",
                                                                  }}
                                                                >
                                                                  {person?.full_name ||
                                                                    " "}{" "}
                                                                </h3>
                                                              </Col>
                                                              <Col md="12">
                                                                {Object.keys(
                                                                  person?.addresses
                                                                ).map(
                                                                  (
                                                                    k,
                                                                    index
                                                                  ) => {
                                                                    const address =
                                                                      person
                                                                        ?.addresses[
                                                                        key
                                                                      ];
                                                                    // Render JSX for each person with title "Relatives"
                                                                    return (
                                                                      <p
                                                                        key={
                                                                          index
                                                                        }
                                                                      >
                                                                        {address?.address1 ||
                                                                          ""}
                                                                        <br />{" "}
                                                                        {
                                                                          address?.city
                                                                        }
                                                                        ,{" "}
                                                                        {
                                                                          address?.state
                                                                        }{" "}
                                                                        {
                                                                          address?.zip
                                                                        }
                                                                      </p>
                                                                    );
                                                                  }
                                                                )}
                                                              </Col>
                                                              <Col md="6">
                                                                <p>
                                                                  <b>AGE:</b>{" "}
                                                                  {person?.age ||
                                                                    "-"}
                                                                </p>
                                                              </Col>
                                                              <Col md="6">
                                                                {" "}
                                                                <p>
                                                                  <b>Gender:</b>{" "}
                                                                  {person?.gender ||
                                                                    "-"}
                                                                </p>
                                                              </Col>
                                                              <Col md="12">
                                                                <p>
                                                                  <b>Birth:</b>{" "}
                                                                  {person?.dob ||
                                                                    "-"}
                                                                </p>
                                                                <p>
                                                                  <b>Death:</b>{" "}
                                                                  {person?.dod ||
                                                                    "-"}
                                                                </p>
                                                              </Col>
                                                            </Row>
                                                          </Col>
                                                          <Col md="7">
                                                            <Row>
                                                              <Col
                                                                xs="10"
                                                                md="9"
                                                              >
                                                                <h5 className="fw-bold">
                                                                  Phone Number
                                                                </h5>{" "}
                                                              </Col>
                                                              <Col
                                                                xs="2"
                                                                md="3"
                                                              ></Col>
                                                            </Row>
                                                            <Row className="g-0">
                                                              {person?.phones &&
                                                                person?.phones?.map(
                                                                  (ph, k) => (
                                                                    <Col
                                                                      xs="6"
                                                                      className="mb-1"
                                                                      key={k}
                                                                    >
                                                                      {ph.phone}
                                                                      <Button
                                                                        className="border-0 btn-transition"
                                                                        outline
                                                                        color="success"
                                                                        onClick={() =>
                                                                          (window.location.href = `tel:${ph?.phone}`)
                                                                        }
                                                                      >
                                                                        <FontAwesomeIcon
                                                                          icon={
                                                                            faPhone
                                                                          }
                                                                          size="1x"
                                                                        />
                                                                      </Button>
                                                                    </Col>
                                                                  )
                                                                )}
                                                            </Row>

                                                            <Row>
                                                              <Col xs="10">
                                                                <h5 className="fw-bold mt-3">
                                                                  Emails{" "}
                                                                </h5>
                                                              </Col>
                                                              <Col xs="2"></Col>
                                                            </Row>

                                                            {person?.emails &&
                                                              person?.emails?.map(
                                                                (e, k) => (
                                                                  <Row
                                                                    className="g-0"
                                                                    key={k}
                                                                  >
                                                                    <Col
                                                                      xs="10"
                                                                      className="mb-1"
                                                                    >
                                                                      {e?.email}
                                                                    </Col>
                                                                    <Col xs="2">
                                                                      <Button
                                                                        className="border-0 btn-transition"
                                                                        outline
                                                                        color="info"
                                                                        title=" Mail"
                                                                        onClick={() =>
                                                                          window.open(
                                                                            `mailto:${e?.email}`
                                                                          )
                                                                        }
                                                                      >
                                                                        <FontAwesomeIcon
                                                                          icon={
                                                                            faEnvelope
                                                                          }
                                                                          size="1x"
                                                                        />
                                                                      </Button>
                                                                    </Col>
                                                                  </Row>
                                                                )
                                                              )}
                                                          </Col>
                                                        </Row>
                                                      </CardBody>
                                                    </Card>
                                                  );
                                                })}
                                          </Row>
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  </Row>
                                )}
                            </Collapse>
                          </CardBody>
                        </Card>
                      </Col>
                    )}

                    {/* prb */}
                    {data?.lead_info?.prb && (
                      <Col md="12">
                        <Card className="main-card mb-2">
                          <CardBody>
                            <CardTitle>
                              <Row>
                                <Col xs="10">
                                  <legend>Probate</legend>
                                </Col>
                                <Col xs="2">
                                  <Button
                                    className="m-0 p-0"
                                    color="link"
                                    onClick={() => setCollapse(!collapse)}
                                  >
                                    {collapse === false ? "Expand" : "Collapse"}
                                  </Button>
                                </Col>
                              </Row>
                            </CardTitle>
                            <Collapse isOpen={collapse}>
                              <Row>
                                <Col md="12">
                                  {data?.lead_info?.prb?.people &&
                                    Object.keys(data?.lead_info?.prb?.people)
                                      .filter(
                                        (key) =>
                                          data?.lead_info?.prb?.people[key]
                                            ?.title !== "Relatives"
                                      )
                                      .map((key, index) => {
                                        const person =
                                          data?.lead_info?.prb?.people[key];
                                        return (
                                          <Card
                                            key={index}
                                            className="main-card mb-1"
                                          >
                                            <CardBody>
                                              <CardTitle></CardTitle>

                                              <Row>
                                                <Col
                                                  md="5"
                                                  className="text-center"
                                                >
                                                  <Row className="g-0">
                                                    <Col md="12">
                                                      <h4 className="text-primary m-0 text-center">
                                                        {person?.title}
                                                      </h4>
                                                    </Col>
                                                    <Col md="12">
                                                      <h3
                                                        style={{
                                                          color: "#003333",
                                                        }}
                                                      >
                                                        {person?.full_name ||
                                                          " "}{" "}
                                                      </h3>
                                                    </Col>
                                                    <Col md="12">
                                                      {Object.keys(
                                                        person?.addresses
                                                      ).map((k, index) => {
                                                        const address =
                                                          person?.addresses[
                                                            key
                                                          ];
                                                        return (
                                                          <p key={index}>
                                                            {address?.address1 ||
                                                              ""}
                                                            <br />{" "}
                                                            {address?.city},{" "}
                                                            {address?.state}{" "}
                                                            {address?.zip}
                                                          </p>
                                                        );
                                                      })}
                                                    </Col>
                                                    <Col md="6">
                                                      <p>
                                                        <b>AGE:</b>{" "}
                                                        {person?.age || "-"}
                                                      </p>
                                                    </Col>
                                                    <Col md="6">
                                                      {" "}
                                                      <p>
                                                        <b>Gender:</b>{" "}
                                                        {person?.gender || "-"}
                                                      </p>
                                                    </Col>
                                                    <Col md="12">
                                                      <p>
                                                        <b>Birth:</b>{" "}
                                                        {person?.dob || "-"}
                                                      </p>
                                                      <p>
                                                        <b>Death:</b>{" "}
                                                        {person?.dod || "-"}
                                                      </p>
                                                    </Col>
                                                  </Row>
                                                </Col>
                                                <Col md="7">
                                                  <Row>
                                                    <Col xs="10" md="9">
                                                      <h5 className="fw-bold">
                                                        Phone Number
                                                      </h5>{" "}
                                                    </Col>
                                                    <Col xs="2" md="3"></Col>
                                                  </Row>
                                                  <Row className="g-0">
                                                    {person?.phones && person?.phones?.map(
                                                      (ph, k) => (
                                                        <Col
                                                          xs="6"
                                                          className="mb-1"
                                                          key={k}
                                                        >
                                                          {ph.phone}
                                                          <Button
                                                            className="border-0 btn-transition"
                                                            outline
                                                            color="success"
                                                            onClick={() =>
                                                              (window.location.href = `tel:${ph?.phone}`)
                                                            }
                                                          >
                                                            <FontAwesomeIcon
                                                              icon={faPhone}
                                                              size="1x"
                                                            />
                                                          </Button>
                                                        </Col>
                                                      )
                                                    )}
                                                  </Row>

                                                  <Row>
                                                    <Col xs="10">
                                                      <h5 className="fw-bold mt-3">
                                                        Emails{" "}
                                                      </h5>
                                                    </Col>
                                                    <Col xs="2"></Col>
                                                  </Row>

                                                  {Array.isArray(person?.emails) && person?.emails.length > 0 && person?.emails.map(
                                                    (e, k) => (
                                                      <Row
                                                        className="g-0"
                                                        key={k}
                                                      >
                                                        <Col
                                                          xs="10"
                                                          className="mb-1"
                                                        >
                                                          {e?.email}
                                                        </Col>
                                                        <Col xs="2">
                                                          <Button
                                                            className="border-0 btn-transition"
                                                            outline
                                                            color="info"
                                                            title=" Mail"
                                                            onClick={() =>
                                                              window.open(
                                                                `mailto:${e?.email}`
                                                              )
                                                            }
                                                          >
                                                            <FontAwesomeIcon
                                                              icon={faEnvelope}
                                                              size="1x"
                                                            />
                                                          </Button>
                                                        </Col>
                                                      </Row>
                                                    )
                                                  )}
                                                </Col>
                                              </Row>
                                            </CardBody>
                                          </Card>
                                        );
                                      })}
                                </Col>
                              </Row>
                              {data?.lead_info?.prb?.people &&
                                Object.keys(
                                  data?.lead_info?.prb?.people
                                ).filter(
                                  (key) =>
                                    data?.lead_info?.prb?.people[key]?.title ===
                                    "Relatives"
                                ).length > 0 && (
                                  <Row>
                                    <Col md="12">
                                      <Card className="main-card mb-1">
                                        <CardBody>
                                          <CardTitle>Relatives</CardTitle>
                                          <Row>
                                            {data?.lead_info?.prb?.people &&
                                              Object.keys(
                                                data?.lead_info?.prb?.people
                                              )
                                                .filter(
                                                  (key) =>
                                                    data?.lead_info?.prb
                                                      ?.people[key]?.title ===
                                                    "Relatives"
                                                )
                                                .map((key, index) => {
                                                  const person =
                                                    data?.lead_info?.prb
                                                      ?.people[key];
                                                  // Render JSX for each person with title "Relatives"
                                                  return (
                                                    <Card className="main-card mb-1">
                                                      <CardBody>
                                                        <CardTitle></CardTitle>

                                                        <Row>
                                                          <Col
                                                            md="5"
                                                            className="text-center"
                                                          >
                                                            <Row className="g-0">
                                                              <Col md="12">
                                                                <h4 className="text-primary m-0 text-center">
                                                                  {
                                                                    person?.title
                                                                  }
                                                                </h4>
                                                              </Col>
                                                              <Col md="12">
                                                                <h3
                                                                  style={{
                                                                    color:
                                                                      "#003333",
                                                                  }}
                                                                >
                                                                  {person?.full_name ||
                                                                    " "}{" "}
                                                                </h3>
                                                              </Col>
                                                              <Col md="12">
                                                                {Object.keys(
                                                                  person?.addresses
                                                                ).map(
                                                                  (
                                                                    k,
                                                                    index
                                                                  ) => {
                                                                    const address =
                                                                      person
                                                                        ?.addresses[
                                                                        key
                                                                      ];
                                                                    // Render JSX for each person with title "Relatives"
                                                                    return (
                                                                      <p
                                                                        key={
                                                                          index
                                                                        }
                                                                      >
                                                                        {address?.address1 ||
                                                                          ""}
                                                                        <br />{" "}
                                                                        {
                                                                          address?.city
                                                                        }
                                                                        ,{" "}
                                                                        {
                                                                          address?.state
                                                                        }{" "}
                                                                        {
                                                                          address?.zip
                                                                        }
                                                                      </p>
                                                                    );
                                                                  }
                                                                )}
                                                              </Col>
                                                              <Col md="6">
                                                                <p>
                                                                  <b>AGE:</b>{" "}
                                                                  {person?.age ||
                                                                    "-"}
                                                                </p>
                                                              </Col>
                                                              <Col md="6">
                                                                {" "}
                                                                <p>
                                                                  <b>Gender:</b>{" "}
                                                                  {person?.gender ||
                                                                    "-"}
                                                                </p>
                                                              </Col>
                                                              <Col md="12">
                                                                <p>
                                                                  <b>Birth:</b>{" "}
                                                                  {person?.dob ||
                                                                    "-"}
                                                                </p>
                                                                <p>
                                                                  <b>Death:</b>{" "}
                                                                  {person?.dod ||
                                                                    "-"}
                                                                </p>
                                                              </Col>
                                                            </Row>
                                                          </Col>
                                                          <Col md="7">
                                                            <Row>
                                                              <Col
                                                                xs="10"
                                                                md="9"
                                                              >
                                                                <h5 className="fw-bold">
                                                                  Phone Number
                                                                </h5>{" "}
                                                              </Col>
                                                              <Col
                                                                xs="2"
                                                                md="3"
                                                              ></Col>
                                                            </Row>
                                                            <Row className="g-0">
                                                              {person?.phones &&
                                                                person?.phones?.map(
                                                                  (ph, k) => (
                                                                    <Col
                                                                      xs="6"
                                                                      className="mb-1"
                                                                      key={k}
                                                                    >
                                                                      {ph.phone}
                                                                      <Button
                                                                        className="border-0 btn-transition"
                                                                        outline
                                                                        color="success"
                                                                        onClick={() =>
                                                                          (window.location.href = `tel:${ph?.phone}`)
                                                                        }
                                                                      >
                                                                        <FontAwesomeIcon
                                                                          icon={
                                                                            faPhone
                                                                          }
                                                                          size="1x"
                                                                        />
                                                                      </Button>
                                                                    </Col>
                                                                  )
                                                                )}
                                                            </Row>

                                                            <Row>
                                                              <Col xs="10">
                                                                <h5 className="fw-bold mt-3">
                                                                  Emails{" "}
                                                                </h5>
                                                              </Col>
                                                              <Col xs="2"></Col>
                                                            </Row>

                                                            {person?.emails &&
                                                              person?.emails?.map(
                                                                (e, k) => (
                                                                  <Row
                                                                    className="g-0"
                                                                    key={k}
                                                                  >
                                                                    <Col
                                                                      xs="10"
                                                                      className="mb-1"
                                                                    >
                                                                      {e?.email}
                                                                    </Col>
                                                                    <Col xs="2">
                                                                      <Button
                                                                        className="border-0 btn-transition"
                                                                        outline
                                                                        color="info"
                                                                        title=" Mail"
                                                                        onClick={() =>
                                                                          window.open(
                                                                            `mailto:${e?.email}`
                                                                          )
                                                                        }
                                                                      >
                                                                        <FontAwesomeIcon
                                                                          icon={
                                                                            faEnvelope
                                                                          }
                                                                          size="1x"
                                                                        />
                                                                      </Button>
                                                                    </Col>
                                                                  </Row>
                                                                )
                                                              )}
                                                          </Col>
                                                        </Row>
                                                      </CardBody>
                                                    </Card>
                                                  );
                                                })}
                                          </Row>
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  </Row>
                                )}
                            </Collapse>
                          </CardBody>
                        </Card>
                      </Col>
                    )}
                    <Row>
                      <Col md="12">
                        <Card className="main-card mb-1">
                          <CardBody>
                            <CardTitle>Owner Detail</CardTitle>
                            <Row>
                              <Card className="main-card mb-1">
                                <CardBody>
                                  <CardTitle></CardTitle>

                                  <Row>
                                    <Col md="5" className="text-center">
                                      <Row className="g-0">
                                        <Col md="12">
                                          <h4 className="text-primary m-0 text-center">
                                            Owner 1
                                          </h4>
                                        </Col>
                                        <Col md="12">
                                          <h3 style={{ color: "#003333" }}>
                                            {data?.owner_type.toLowerCase() ==
                                            "company"
                                              ? data?.owner_full_name
                                              : (data?.owner_first_name || "") +
                                                " " +
                                                (data?.owner_middle_name ||
                                                  "") +
                                                " " +
                                                (data?.owner_last_name || "") +
                                                " " +
                                                (data?.owner_suffix || "")}
                                          </h3>
                                        </Col>
                                        <Col md="6">
                                          <p>
                                            <b>AGE:</b> {data?.owner_age || "-"}
                                          </p>
                                        </Col>
                                        <Col md="6">
                                          {" "}
                                          <p>
                                            <b>Type:</b>{" "}
                                            {data?.owner_type || "-"}
                                          </p>
                                        </Col>
                                        <Col md="12">
                                          <p>
                                            <b>Property Count:</b>{" "}
                                            {data?.owner_property_count || "-"}
                                          </p>
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col md="7">
                                      <Row>
                                        <Col xs="10" md="9">
                                          <h5 className="fw-bold">
                                            Phone number
                                          </h5>{" "}
                                        </Col>
                                        <Col xs="2" md="3">
                                          <Button
                                            color="link"
                                            onClick={() => {
                                              setCustom(!custom);
                                              setBtn("Add");
                                            }}
                                          >
                                            ADD
                                          </Button>
                                        </Col>
                                      </Row>

                                      <Collapse isOpen={custom}>
                                        <div className="mb-3 m-0 p-0">
                                          <Row>
                                            <Col md="12">
                                              <InputMask
                                                className="form-control"
                                                mask="(999) 999-9999"
                                                placeholder="(123) 456-7890"
                                                maskChar={null}
                                                value={
                                                  phoneData.phone_number || ""
                                                }
                                                onChange={(e) =>
                                                  handleChange2(
                                                    e.target.value,
                                                    "phone_number"
                                                  )
                                                }
                                              />
                                              <div
                                                style={
                                                  phoneValidate?.hasErrors
                                                    ? { display: "block" }
                                                    : { display: "none" }
                                                }
                                                className="invalid-feedback"
                                              >
                                                {phoneValidate?.phone_number}
                                              </div>
                                              <div
                                                style={
                                                  !phoneValidate.hasErrors
                                                    ? { display: "block" }
                                                    : { display: "none" }
                                                }
                                                className="valid-feedback"
                                              >
                                                {phoneValidate?.phone_number}
                                              </div>
                                            </Col>
                                            <Col md="12">
                                              <Input
                                                type="select"
                                                className="mt-2"
                                                value={
                                                  phoneData.phone_type || " "
                                                }
                                                onChange={(e) =>
                                                  handleChange2(
                                                    e.target.value,
                                                    "phone_type"
                                                  )
                                                }
                                              >
                                                <option>Unknown</option>
                                                <option>Landline</option>
                                                <option>Mobile</option>
                                                <option>VoIP</option>
                                              </Input>
                                            </Col>

                                            <Col md="12" className="mt-2">
                                              <Input
                                                type="select"
                                                className="mt-2"
                                                value={
                                                  phoneData.phone_status || " "
                                                }
                                                onChange={(e) =>
                                                  handleChange2(
                                                    e.target.value,
                                                    "phone_status"
                                                  )
                                                }
                                              >
                                                {" "}
                                                <option
                                                  value=""
                                                  disabled={
                                                    !!phoneData.phone_status
                                                  }
                                                >
                                                  Phone Status
                                                </option>
                                                <option>Good</option>
                                                <option>Contacted</option>
                                                <option>Wrong Person</option>
                                                <option>Disconnected</option>
                                                <option>No Answer</option>
                                                <option>DNC</option>
                                                <option>Left VM</option>
                                              </Input>
                                            </Col>

                                            <Col md="6" className="mt-2">
                                              <Button
                                                block
                                                outline
                                                className=" btn-wide mb-2 me-2 btn-transition"
                                                color="secondary"
                                                onClick={() =>
                                                  phoneValueCancel()
                                                }
                                              >
                                                Cancel
                                              </Button>
                                            </Col>
                                            <Col md="6" className="mt-2">
                                              <Button
                                                block
                                                outline
                                                className="btn-wide mb-2 me-2 btn-transition"
                                                color="primary"
                                                onClick={addUpdatePhone}
                                              >
                                                {phoneRequesting ? (
                                                  <>
                                                    <Spinner size="sm" />
                                                    <span className="mb-2">
                                                      {" "}
                                                      {btn}ing
                                                    </span>{" "}
                                                  </>
                                                ) : (
                                                  btn
                                                )}
                                              </Button>
                                            </Col>
                                          </Row>
                                        </div>
                                      </Collapse>
                                      {phone?.map((ph, key) => {
                                        return (
                                          <Row key={key} className="g-0">
                                            <Col xs="7" className="mt-1">
                                              {ph?.phone || "none"}
                                            </Col>
                                            <Col xs="5">
                                              {ph?.user_defined !== 1 ? (
                                                <Button
                                                  className="border-0 btn-transition"
                                                  outline
                                                  color="success"
                                                  title=" Call"
                                                  onClick={() =>
                                                    (window.location.href = `tel:${ph?.phone}`)
                                                  }
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faPhone}
                                                    size="1x"
                                                  />
                                                </Button>
                                              ) : (
                                                <div>
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="primary"
                                                    onClick={() => {
                                                      setCustom(!custom);
                                                      setBtn("Edit");
                                                      setPhoneData({
                                                        ...state1,
                                                        phone_number: ph?.phone,
                                                        old_phone_no: ph?.phone,
                                                        phone_type: ph?.type,
                                                        phone_status:
                                                          ph?.status,
                                                      });
                                                    }}
                                                    title=" Edit"
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faPen}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="danger"
                                                    onClick={() => {
                                                      setAlert1(true);
                                                      setSpecificPhone(
                                                        ph?.phone
                                                      );
                                                    }}
                                                    title=" Delete"
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faTrashAlt}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="success"
                                                    title=" Call"
                                                    onClick={() =>
                                                      (window.location.href = `tel:${ph?.phone}`)
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faPhone}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        );
                                      })}
                                      {alert1 && (
                                        <Portal id="sweet-alert-portal">
                                          <SweetAlert
                                            r
                                            title="Are you sure?"
                                            show={alert1}
                                            type="danger"
                                            onConfirm={deletePhone}
                                            onCancel={() => setAlert1(false)}
                                            showCancel
                                            confirmBtnText={
                                              deleteRequesting ? (
                                                <>
                                                  <Spinner size="sm" />
                                                  <span className="mb-2">
                                                    {" "}
                                                    Deleting
                                                  </span>{" "}
                                                </>
                                              ) : (
                                                "Yes, delete it!"
                                              )
                                            }
                                            confirmBtnBsStyle="danger"
                                            cancelBtnBsStyle="info"
                                          />
                                        </Portal>
                                      )}

                                      <Row>
                                        <Col xs="10" md="9">
                                          <h5 className="fw-bold mt-3">
                                            Emails{" "}
                                          </h5>
                                        </Col>
                                        <Col xs="2" md="3" className="mt-3">
                                          <Button
                                            className=" "
                                            color="link"
                                            onClick={() => {
                                              setCustom2(!custom2);
                                              setBtn("Add");
                                            }}
                                          >
                                            ADD
                                          </Button>
                                        </Col>
                                      </Row>

                                      <Collapse isOpen={custom2}>
                                        <div className="mb-3">
                                          <Row>
                                            <Col md="12" className="mt-2">
                                              <Input
                                                type="email"
                                                value={emailData.email || " "}
                                                valid={
                                                  emailValidate.validate ===
                                                  "has-success"
                                                }
                                                invalid={
                                                  emailValidate.validate ===
                                                  "has-danger"
                                                }
                                                placeholder="email@exmaple.com"
                                                onChange={(e) =>
                                                  handleChange1(
                                                    e.target.value,
                                                    "email"
                                                  )
                                                }
                                              />
                                              <Col md="12">
                                                <Input
                                                  type="select"
                                                  className="mt-2"
                                                >
                                                  <option>Not Verified</option>
                                                  <option>Verified</option>
                                                  <option>
                                                    Verified, Contacted
                                                  </option>
                                                  <option>
                                                    Do not contact
                                                  </option>
                                                </Input>
                                              </Col>
                                              <FormFeedback>
                                                Please input a complete correct
                                                email.
                                              </FormFeedback>
                                              <FormFeedback valid>
                                                That's a tasty looking email
                                                you've got there.
                                              </FormFeedback>
                                            </Col>
                                            <Col md="6" className="mt-2">
                                              <Button
                                                block
                                                outline
                                                className=" btn-wide mb-2 me-2 btn-transition"
                                                color="secondary"
                                                onClick={() =>
                                                  emailValueCancel()
                                                }
                                              >
                                                Cancel
                                              </Button>
                                            </Col>
                                            <Col md="6" className="mt-2">
                                              <Button
                                                block
                                                outline
                                                className="btn-wide mb-2 me-2 btn-transition"
                                                color="primary"
                                                onClick={addUpdateEmail}
                                              >
                                                {emailRequesting ? (
                                                  <>
                                                    <Spinner size="sm" />
                                                    <span className="mb-2">
                                                      {" "}
                                                      {btn}ing
                                                    </span>{" "}
                                                  </>
                                                ) : (
                                                  btn
                                                )}
                                              </Button>
                                            </Col>
                                          </Row>
                                        </div>
                                      </Collapse>

                                      {email?.map((ph, key) => {
                                        return (
                                          <Row key={key} className="g-0">
                                            <Col xs="7">
                                              {ph?.email || "none"}
                                            </Col>
                                            <Col xs="5">
                                              {ph?.user_defined !== 1 ? (
                                                <Button
                                                  className="border-0 btn-transition"
                                                  outline
                                                  color="info"
                                                  title="Mail"
                                                  onClick={() =>
                                                    window.open(
                                                      `mailto:${ph?.email}`
                                                    )
                                                  }
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faEnvelope}
                                                    size="1x"
                                                  />
                                                </Button>
                                              ) : (
                                                <div className="text-danger">
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="primary"
                                                    onClick={() => {
                                                      setCustom2(!custom2);
                                                      setBtn("Edit");
                                                      setEmailData({
                                                        ...state2,
                                                        email: ph?.email,
                                                        old_email: ph?.email,
                                                      });
                                                    }}
                                                    title=" Edit"
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faPen}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="danger"
                                                    onClick={() => {
                                                      setAlert2(true);
                                                      setSpecificEmail(
                                                        ph?.email
                                                      );
                                                    }}
                                                    title=" Delete"
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faTrashAlt}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="info"
                                                    title=" Mail"
                                                    onClick={() =>
                                                      window.open(
                                                        `mailto:${ph?.email}`
                                                      )
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faEnvelope}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        );
                                      })}

                                      {alert2 && (
                                        <Portal id="sweet-alert-portal">
                                          <SweetAlert
                                            title="Are you sure?"
                                            show={alert2}
                                            type="danger"
                                            onConfirm={deleteEmail}
                                            onCancel={() => setAlert2(false)}
                                            showCancel
                                            confirmBtnText={
                                              deleteRequesting ? (
                                                <>
                                                  <Spinner size="sm" />
                                                  <span className="mb-2">
                                                    {" "}
                                                    Deleting
                                                  </span>{" "}
                                                </>
                                              ) : (
                                                "Yes, delete it!"
                                              )
                                            }
                                            confirmBtnBsStyle="danger"
                                            cancelBtnBsStyle="info"
                                          />
                                        </Portal>
                                      )}
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                              {data?.owner2_full_name && (
                                <Card className="main-card mb-1">
                                  <CardBody>
                                    <CardTitle></CardTitle>

                                    <Row>
                                      <Col md="5" className="text-center">
                                        <Row className="g-0">
                                          <Col md="12">
                                            <h4 className="text-primary m-0 text-center">
                                              Owner 2
                                            </h4>
                                          </Col>
                                          <Col md="12">
                                            <h3 style={{ color: "#003333" }}>
                                              {data?.owner2_first_name || ""}{" "}
                                              {data?.owner2_middle_name || ""}{" "}
                                              {data?.owner2_last_name || ""}{" "}
                                              {data?.owner2_suffix || ""}
                                            </h3>
                                          </Col>
                                          <Col md="6">
                                            <p>
                                              <b>AGE:</b>{" "}
                                              {data?.owner2_age || "-"}
                                            </p>
                                          </Col>
                                          <Col md="6">
                                            {" "}
                                            <p>
                                              <b>Type:</b>{" "}
                                              {data?.owner2_type || "-"}
                                            </p>
                                          </Col>
                                          <Col md="12">
                                            <p>
                                              <b>Property Count:</b>{" "}
                                              {data?.owner2_property_count ||
                                                "-"}
                                            </p>
                                          </Col>
                                        </Row>
                                      </Col>

                                      <Col md="7">
                                        <Row>
                                          <Col xs="10" md="9">
                                            <h5 className="fw-bold">
                                              Phone number
                                            </h5>{" "}
                                          </Col>
                                          <Col xs="2" md="3">
                                            <Button
                                              color="link"
                                              onClick={() => {
                                                setCustom(!custom);
                                                setBtn("Add");
                                              }}
                                            >
                                              ADD
                                            </Button>
                                          </Col>
                                        </Row>

                                        <Collapse isOpen={custom}>
                                          <div className="mb-3 m-0 p-0">
                                            <Row>
                                              <Col md="12">
                                                <InputMask
                                                  className="form-control"
                                                  mask="(999) 999-9999"
                                                  placeholder="(123) 456-7890"
                                                  maskChar={null}
                                                  value={
                                                    phoneData.phone_number || ""
                                                  }
                                                  onChange={(e) =>
                                                    handleChange2(
                                                      e.target.value,
                                                      "phone_number"
                                                    )
                                                  }
                                                />
                                                <div
                                                  style={
                                                    phoneValidate?.hasErrors
                                                      ? { display: "block" }
                                                      : { display: "none" }
                                                  }
                                                  className="invalid-feedback"
                                                >
                                                  {phoneValidate?.phone_number}
                                                </div>
                                                <div
                                                  style={
                                                    !phoneValidate.hasErrors
                                                      ? { display: "block" }
                                                      : { display: "none" }
                                                  }
                                                  className="valid-feedback"
                                                >
                                                  {phoneValidate?.phone_number}
                                                </div>
                                              </Col>
                                              <Col md="12">
                                                <Input
                                                  type="select"
                                                  className="mt-2"
                                                  value={
                                                    phoneData.phone_type || " "
                                                  }
                                                  onChange={(e) =>
                                                    handleChange2(
                                                      e.target.value,
                                                      "phone_type"
                                                    )
                                                  }
                                                >
                                                  <option>Unknown</option>
                                                  <option>Landline</option>
                                                  <option>Mobile</option>
                                                  <option>VoIP</option>
                                                </Input>
                                              </Col>

                                              <Col md="12" className="mt-2">
                                                <Input
                                                  type="select"
                                                  className="mt-2"
                                                  value={
                                                    phoneData.phone_status ||
                                                    " "
                                                  }
                                                  onChange={(e) =>
                                                    handleChange2(
                                                      e.target.value,
                                                      "phone_status"
                                                    )
                                                  }
                                                >
                                                  {" "}
                                                  <option
                                                    value=""
                                                    disabled={
                                                      !!phoneData.phone_status
                                                    }
                                                  >
                                                    Phone Status
                                                  </option>
                                                  <option>Good</option>
                                                  <option>Contacted</option>
                                                  <option>Wrong Person</option>
                                                  <option>Disconnected</option>
                                                  <option>No Answer</option>
                                                  <option>DNC</option>
                                                  <option>Left VM</option>
                                                </Input>
                                              </Col>

                                              <Col md="6" className="mt-2">
                                                <Button
                                                  block
                                                  outline
                                                  className=" btn-wide mb-2 me-2 btn-transition"
                                                  color="secondary"
                                                  onClick={() =>
                                                    phoneValueCancel()
                                                  }
                                                >
                                                  Cancel
                                                </Button>
                                              </Col>
                                              <Col md="6" className="mt-2">
                                                <Button
                                                  block
                                                  outline
                                                  className="btn-wide mb-2 me-2 btn-transition"
                                                  color="primary"
                                                  onClick={addUpdatePhone}
                                                >
                                                  {phoneRequesting ? (
                                                    <>
                                                      <Spinner size="sm" />
                                                      <span className="mb-2">
                                                        {" "}
                                                        {btn}ing
                                                      </span>{" "}
                                                    </>
                                                  ) : (
                                                    btn
                                                  )}
                                                </Button>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Collapse>
                                        {phone?.map((ph, key) => {
                                          return (
                                            <Row key={key} className="g-0">
                                              <Col xs="7" className="mt-1">
                                                {ph?.phone || "none"}
                                              </Col>
                                              <Col xs="5">
                                                {ph?.user_defined !== 1 ? (
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="success"
                                                    title=" Call"
                                                    onClick={() =>
                                                      (window.location.href = `tel:${ph?.phone}`)
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faPhone}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                ) : (
                                                  <div>
                                                    <Button
                                                      className="border-0 btn-transition"
                                                      outline
                                                      color="primary"
                                                      onClick={() => {
                                                        setCustom(!custom);
                                                        setBtn("Edit");
                                                        setPhoneData({
                                                          ...state1,
                                                          phone_number:
                                                            ph?.phone,
                                                          old_phone_no:
                                                            ph?.phone,
                                                          phone_type: ph?.type,
                                                          phone_status:
                                                            ph?.status,
                                                        });
                                                      }}
                                                      title=" Edit"
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faPen}
                                                        size="1x"
                                                      />
                                                    </Button>
                                                    <Button
                                                      className="border-0 btn-transition"
                                                      outline
                                                      color="danger"
                                                      onClick={() => {
                                                        setAlert1(true);
                                                        setSpecificPhone(
                                                          ph?.phone
                                                        );
                                                      }}
                                                      title=" Delete"
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faTrashAlt}
                                                        size="1x"
                                                      />
                                                    </Button>
                                                    <Button
                                                      className="border-0 btn-transition"
                                                      outline
                                                      color="success"
                                                      title=" Call"
                                                      onClick={() =>
                                                        (window.location.href = `tel:${ph?.phone}`)
                                                      }
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faPhone}
                                                        size="1x"
                                                      />
                                                    </Button>
                                                  </div>
                                                )}
                                              </Col>
                                            </Row>
                                          );
                                        })}
                                        {alert1 && (
                                          <Portal id="sweet-alert-portal">
                                            <SweetAlert
                                              r
                                              title="Are you sure?"
                                              show={alert1}
                                              type="danger"
                                              onConfirm={deletePhone}
                                              onCancel={() => setAlert1(false)}
                                              showCancel
                                              confirmBtnText={
                                                deleteRequesting ? (
                                                  <>
                                                    <Spinner size="sm" />
                                                    <span className="mb-2">
                                                      {" "}
                                                      Deleting
                                                    </span>{" "}
                                                  </>
                                                ) : (
                                                  "Yes, delete it!"
                                                )
                                              }
                                              confirmBtnBsStyle="danger"
                                              cancelBtnBsStyle="info"
                                            />
                                          </Portal>
                                        )}

                                        <Row>
                                          <Col xs="10" md="9">
                                            <h5 className="fw-bold mt-3">
                                              Emails{" "}
                                            </h5>
                                          </Col>
                                          <Col xs="2" md="3" className="mt-3">
                                            <Button
                                              className=" "
                                              color="link"
                                              onClick={() => {
                                                setCustom2(!custom2);
                                                setBtn("Add");
                                              }}
                                            >
                                              ADD
                                            </Button>
                                          </Col>
                                        </Row>

                                        <Collapse isOpen={custom2}>
                                          <div className="mb-3">
                                            <Row>
                                              <Col md="12" className="mt-2">
                                                <Input
                                                  type="email"
                                                  value={emailData.email || " "}
                                                  valid={
                                                    emailValidate.validate ===
                                                    "has-success"
                                                  }
                                                  invalid={
                                                    emailValidate.validate ===
                                                    "has-danger"
                                                  }
                                                  placeholder="email@exmaple.com"
                                                  onChange={(e) =>
                                                    handleChange1(
                                                      e.target.value,
                                                      "email"
                                                    )
                                                  }
                                                />
                                                <Col md="12">
                                                  <Input
                                                    type="select"
                                                    className="mt-2"
                                                  >
                                                    <option>
                                                      Not Verified
                                                    </option>
                                                    <option>Verified</option>
                                                    <option>
                                                      Verified, Contacted
                                                    </option>
                                                    <option>
                                                      Do not contact
                                                    </option>
                                                  </Input>
                                                </Col>
                                                <FormFeedback>
                                                  Please input a complete
                                                  correct email.
                                                </FormFeedback>
                                                <FormFeedback valid>
                                                  That's a tasty looking email
                                                  you've got there.
                                                </FormFeedback>
                                              </Col>
                                              <Col md="6" className="mt-2">
                                                <Button
                                                  block
                                                  outline
                                                  className=" btn-wide mb-2 me-2 btn-transition"
                                                  color="secondary"
                                                  onClick={() =>
                                                    emailValueCancel()
                                                  }
                                                >
                                                  Cancel
                                                </Button>
                                              </Col>
                                              <Col md="6" className="mt-2">
                                                <Button
                                                  block
                                                  outline
                                                  className="btn-wide mb-2 me-2 btn-transition"
                                                  color="primary"
                                                  onClick={addUpdateEmail}
                                                >
                                                  {emailRequesting ? (
                                                    <>
                                                      <Spinner size="sm" />
                                                      <span className="mb-2">
                                                        {" "}
                                                        {btn}ing
                                                      </span>{" "}
                                                    </>
                                                  ) : (
                                                    btn
                                                  )}
                                                </Button>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Collapse>

                                        {email?.map((ph, key) => {
                                          return (
                                            <Row key={key} className="g-0">
                                              <Col xs="7">
                                                {ph?.email || "none"}
                                              </Col>
                                              <Col xs="5">
                                                {ph?.user_defined !== 1 ? (
                                                  <Button
                                                    className="border-0 btn-transition"
                                                    outline
                                                    color="info"
                                                    title="Mail"
                                                    onClick={() =>
                                                      window.open(
                                                        `mailto:${ph?.email}`
                                                      )
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faEnvelope}
                                                      size="1x"
                                                    />
                                                  </Button>
                                                ) : (
                                                  <div className="text-danger">
                                                    <Button
                                                      className="border-0 btn-transition"
                                                      outline
                                                      color="primary"
                                                      onClick={() => {
                                                        setCustom2(!custom2);
                                                        setBtn("Edit");
                                                        setEmailData({
                                                          ...state2,
                                                          email: ph?.email,
                                                          old_email: ph?.email,
                                                        });
                                                      }}
                                                      title=" Edit"
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faPen}
                                                        size="1x"
                                                      />
                                                    </Button>
                                                    <Button
                                                      className="border-0 btn-transition"
                                                      outline
                                                      color="danger"
                                                      onClick={() => {
                                                        setAlert2(true);
                                                        setSpecificEmail(
                                                          ph?.email
                                                        );
                                                      }}
                                                      title=" Delete"
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faTrashAlt}
                                                        size="1x"
                                                      />
                                                    </Button>
                                                    <Button
                                                      className="border-0 btn-transition"
                                                      outline
                                                      color="info"
                                                      title=" Mail"
                                                      onClick={() =>
                                                        window.open(
                                                          `mailto:${ph?.email}`
                                                        )
                                                      }
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faEnvelope}
                                                        size="1x"
                                                      />
                                                    </Button>
                                                  </div>
                                                )}
                                              </Col>
                                            </Row>
                                          );
                                        })}

                                        {alert2 && (
                                          <Portal id="sweet-alert-portal">
                                            <SweetAlert
                                              title="Are you sure?"
                                              show={alert2}
                                              type="danger"
                                              onConfirm={deleteEmail}
                                              onCancel={() => setAlert2(false)}
                                              showCancel
                                              confirmBtnText={
                                                deleteRequesting ? (
                                                  <>
                                                    <Spinner size="sm" />
                                                    <span className="mb-2">
                                                      {" "}
                                                      Deleting
                                                    </span>{" "}
                                                  </>
                                                ) : (
                                                  "Yes, delete it!"
                                                )
                                              }
                                              confirmBtnBsStyle="danger"
                                              cancelBtnBsStyle="info"
                                            />
                                          </Portal>
                                        )}
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              )}
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    {/*============= new Rows added at the bottom of this ===========================*/}
                    {data?.lead_info?.user_defined &&
                      (addressId || recordId) && (
                        <>
                          {" "}
                          {data?.lead_info?.user_defined?.people.map(
                            (info, key) => (
                              <Row key={key}>
                                <Col md="12">
                                  <Card className="main-card mb-1">
                                    <CardBody>
                                      <CardTitle></CardTitle>

                                      <Row>
                                        <Col md="5">
                                          <h4 className="text-primary m-0 text-center">
                                            {info?.title}
                                          </h4>
                                          <h3
                                            className="text-center"
                                            style={{ color: "#003333" }}
                                          >
                                            {info?.first_name || ""}{" "}
                                            {info?.middle_name || ""}{" "}
                                            {info?.last_name || ""}{" "}
                                          </h3>

                                          <p className="text-center">
                                            {info?.addresses[0]?.address1 || ""}
                                            <br /> {
                                              info?.addresses[0]?.city
                                            }, {info?.addresses[0]?.state}{" "}
                                            {info?.addresses[0]?.zip}
                                          </p>
                                        </Col>
                                        <Col md="7">
                                          <Row>
                                            <Col xs="10" md="9">
                                              <h5 className="fw-bold">
                                                Phone Number
                                              </h5>{" "}
                                            </Col>
                                            <Col xs="2" md="3">
                                              {/* <Button
                                  color="link"
                                  onClick={() => setPetitCustom1(!petitCustom1)}
                                >
                                  ADD
                                </Button> */}
                                            </Col>
                                          </Row>
                                          <Collapse isOpen={petitCustom1}>
                                            <div className="mb-3 m-0 p-0">
                                              <Row>
                                                <Col md="12">
                                                  <Input
                                                    type="email"
                                                    className="mt-1"
                                                    placeholder="(999) 999-9999"
                                                  />
                                                  <FormFeedback>
                                                    Please input a complete
                                                    correct phone number.
                                                  </FormFeedback>
                                                  <FormFeedback valid>
                                                    That's a correct phone
                                                    number you've entered there.
                                                  </FormFeedback>
                                                </Col>
                                                <Col md="12">
                                                  <Input
                                                    type="select"
                                                    className="mt-2"
                                                  >
                                                    <option>Unknown</option>
                                                    <option>Landline</option>
                                                    <option>Mobile</option>
                                                    <option>VoIP</option>
                                                  </Input>
                                                </Col>
                                                <Col md="12" className="mt-2">
                                                  <DropdownList
                                                    defaultValue="Red"
                                                    renderListItem={renderColor}
                                                    data={[
                                                      "Red",
                                                      "Yellow",
                                                      "Blue",
                                                      "Orange",
                                                    ]}
                                                    renderValue={
                                                      customRenderValue
                                                    }
                                                  />
                                                </Col>

                                                <Col md="6" className="mt-2">
                                                  <Button
                                                    block
                                                    outline
                                                    className=" btn-wide mb-2 me-2 btn-transition"
                                                    color="secondary"
                                                    onClick={() =>
                                                      setPetitCustom1(
                                                        !petitCustom1
                                                      )
                                                    }
                                                  >
                                                    Cancel
                                                  </Button>
                                                </Col>
                                                <Col md="6" className="mt-2">
                                                  <Button
                                                    block
                                                    disabled
                                                    outline
                                                    className="btn-wide mb-2 me-2 btn-transition"
                                                    color="primary"
                                                  >
                                                    Add
                                                  </Button>
                                                </Col>
                                              </Row>
                                            </div>
                                          </Collapse>

                                          <Row className="g-1">
                                            <Col xs="10">
                                              {data?.lead_info?.probate
                                                ?.lead_info?.PetitionerPhones ||
                                                ""}
                                            </Col>
                                            <Col xs="2">
                                              {data?.lead_info?.probate
                                                ?.lead_info
                                                ?.PetitionerPhones && (
                                                <Button
                                                  className="border-0 btn-transition"
                                                  outline
                                                  color="success"
                                                  title=" Call"
                                                  onClick={() =>
                                                    (window.location.href = `tel:${data?.lead_info?.probate?.lead_info?.PetitionerPhones}`)
                                                  }
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faPhone}
                                                    size="1x"
                                                  />
                                                </Button>
                                              )}
                                            </Col>
                                          </Row>

                                          <Row>
                                            <Col xs="10" md="9">
                                              <h5 className="fw-bold mt-3">
                                                Emails{" "}
                                              </h5>
                                            </Col>
                                            <Col xs="2" md="3" className="mt-2">
                                              {/* <Button
                                  className=" "
                                  color="link"
                                  onClick={() => setPetitCustom2(!petitCustom2)}
                                >
                                  ADD
                                </Button> */}
                                            </Col>
                                          </Row>
                                          <Collapse isOpen={petitCustom2}>
                                            <div className="mb-3">
                                              <Row>
                                                <Col md="12" className="mt-2">
                                                  <Input
                                                    type="email"
                                                    valid={
                                                      emailValidate.validate ===
                                                      "has-success"
                                                    }
                                                    invalid={
                                                      emailValidate.validate ===
                                                      "has-danger"
                                                    }
                                                    placeholder="email@exmaple.com"
                                                  />
                                                  <FormFeedback>
                                                    Please input a complete
                                                    correct email.
                                                  </FormFeedback>
                                                  <FormFeedback valid>
                                                    That's a tasty looking email
                                                    you've got there.
                                                  </FormFeedback>
                                                </Col>
                                                <Col md="6" className="mt-2">
                                                  <Button
                                                    block
                                                    outline
                                                    className=" btn-wide mb-2 me-2 btn-transition"
                                                    color="secondary"
                                                    onClick={() =>
                                                      setPetitCustom2(
                                                        !petitCustom2
                                                      )
                                                    }
                                                  >
                                                    Cancel
                                                  </Button>
                                                </Col>
                                                <Col md="6" className="mt-2">
                                                  <Button
                                                    disabled
                                                    block
                                                    outline
                                                    className="btn-wide mb-2 me-2 btn-transition"
                                                    color="primary"
                                                  >
                                                    Add
                                                  </Button>
                                                </Col>
                                              </Row>
                                            </div>
                                          </Collapse>

                                          <Row className="g-1">
                                            <Col xs="10">
                                              {data?.lead_info?.probate
                                                ?.lead_info?.PetitionerEmails ||
                                                ""}
                                            </Col>
                                            <Col xs="2">
                                              {data?.lead_info?.probate
                                                ?.lead_info
                                                ?.PetitionerEmails && (
                                                <Button
                                                  className="border-0 btn-transition"
                                                  outline
                                                  color="info"
                                                  title=" Mail"
                                                  onClick={() =>
                                                    window.open(
                                                      `mailto:${data?.lead_info?.probate?.lead_info?.PetitionerEmails}`
                                                    )
                                                  }
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faEnvelope}
                                                    size="1x"
                                                  />
                                                </Button>
                                              )}
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Card>
                                </Col>
                              </Row>
                            )
                          )}
                        </>
                      )}
                    {data?.lead_info?.probate && (addressId || recordId) && (
                      <Row>
                        <Col md="12">
                          <Card className="main-card mb-1">
                            <CardBody>
                              <CardTitle></CardTitle>

                              <Row>
                                <Col md="5">
                                  <h4 className="text-primary m-0 text-center">
                                    Petitioner
                                  </h4>
                                  <h3
                                    className="text-center"
                                    style={{ color: "#003333" }}
                                  >
                                    {data?.lead_info?.probate?.lead_info
                                      ?.PetitionerFullName || ""}{" "}
                                  </h3>

                                  <p className="text-center">
                                    {data?.lead_info?.probate?.lead_info
                                      ?.PetitionerAddress || ""}
                                    <br />{" "}
                                    {
                                      data?.lead_info?.probate?.lead_info
                                        ?.PetitionerCity
                                    }
                                    ,{" "}
                                    {
                                      data?.lead_info?.probate?.lead_info
                                        ?.PetitionerState
                                    }{" "}
                                    {
                                      data?.lead_info?.probate?.lead_info
                                        ?.PetitionerZip
                                    }
                                  </p>
                                </Col>
                                <Col md="7">
                                  <Row>
                                    <Col xs="10" md="9">
                                      <h5 className="fw-bold">Phone Number</h5>{" "}
                                    </Col>
                                    <Col xs="2" md="3">
                                      {/* <Button
                                    color="link"
                                    onClick={() => setPetitCustom1(!petitCustom1)}
                                  >
                                    ADD
                                  </Button> */}
                                    </Col>
                                  </Row>
                                  <Collapse isOpen={petitCustom1}>
                                    <div className="mb-3 m-0 p-0">
                                      <Row>
                                        <Col md="12">
                                          <Input
                                            type="email"
                                            className="mt-1"
                                            placeholder="(999) 999-9999"
                                          />
                                          <FormFeedback>
                                            Please input a complete correct
                                            phone number.
                                          </FormFeedback>
                                          <FormFeedback valid>
                                            That's a correct phone number you've
                                            entered there.
                                          </FormFeedback>
                                        </Col>
                                        <Col md="12">
                                          <Input type="select" className="mt-2">
                                            <option>Unknown</option>
                                            <option>Landline</option>
                                            <option>Mobile</option>
                                            <option>VoIP</option>
                                          </Input>
                                        </Col>
                                        <Col md="12" className="mt-2">
                                          <DropdownList
                                            defaultValue="Red"
                                            renderListItem={renderColor}
                                            data={[
                                              "Red",
                                              "Yellow",
                                              "Blue",
                                              "Orange",
                                            ]}
                                            renderValue={customRenderValue}
                                          />
                                        </Col>

                                        <Col md="6" className="mt-2">
                                          <Button
                                            block
                                            outline
                                            className=" btn-wide mb-2 me-2 btn-transition"
                                            color="secondary"
                                            onClick={() =>
                                              setPetitCustom1(!petitCustom1)
                                            }
                                          >
                                            Cancel
                                          </Button>
                                        </Col>
                                        <Col md="6" className="mt-2">
                                          <Button
                                            block
                                            disabled
                                            outline
                                            className="btn-wide mb-2 me-2 btn-transition"
                                            color="primary"
                                          >
                                            Add
                                          </Button>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Collapse>

                                  <Row className="g-1">
                                    <Col xs="10">
                                      {data?.lead_info?.probate?.lead_info
                                        ?.PetitionerPhones || ""}
                                    </Col>
                                    <Col xs="2">
                                      {data?.lead_info?.probate?.lead_info
                                        ?.PetitionerPhones && (
                                        <Button
                                          className="border-0 btn-transition"
                                          outline
                                          color="success"
                                          title=" Call"
                                          onClick={() =>
                                            (window.location.href = `tel:${data?.lead_info?.probate?.lead_info?.PetitionerPhones}`)
                                          }
                                        >
                                          <FontAwesomeIcon
                                            icon={faPhone}
                                            size="1x"
                                          />
                                        </Button>
                                      )}
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col xs="10" md="9">
                                      <h5 className="fw-bold mt-3">Emails </h5>
                                    </Col>
                                    <Col xs="2" md="3" className="mt-2">
                                      {/* <Button
                                    className=" "
                                    color="link"
                                    onClick={() => setPetitCustom2(!petitCustom2)}
                                  >
                                    ADD
                                  </Button> */}
                                    </Col>
                                  </Row>
                                  <Collapse isOpen={petitCustom2}>
                                    <div className="mb-3">
                                      <Row>
                                        <Col md="12" className="mt-2">
                                          <Input
                                            type="email"
                                            valid={
                                              emailValidate.validate ===
                                              "has-success"
                                            }
                                            invalid={
                                              emailValidate.validate ===
                                              "has-danger"
                                            }
                                            placeholder="email@exmaple.com"
                                          />
                                          <FormFeedback>
                                            Please input a complete correct
                                            email.
                                          </FormFeedback>
                                          <FormFeedback valid>
                                            That's a tasty looking email you've
                                            got there.
                                          </FormFeedback>
                                        </Col>
                                        <Col md="6" className="mt-2">
                                          <Button
                                            block
                                            outline
                                            className=" btn-wide mb-2 me-2 btn-transition"
                                            color="secondary"
                                            onClick={() =>
                                              setPetitCustom2(!petitCustom2)
                                            }
                                          >
                                            Cancel
                                          </Button>
                                        </Col>
                                        <Col md="6" className="mt-2">
                                          <Button
                                            disabled
                                            block
                                            outline
                                            className="btn-wide mb-2 me-2 btn-transition"
                                            color="primary"
                                          >
                                            Add
                                          </Button>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Collapse>

                                  <Row className="g-1">
                                    <Col xs="10">
                                      {data?.lead_info?.probate?.lead_info
                                        ?.PetitionerEmails || ""}
                                    </Col>
                                    <Col xs="2">
                                      {data?.lead_info?.probate?.lead_info
                                        ?.PetitionerEmails && (
                                        <Button
                                          className="border-0 btn-transition"
                                          outline
                                          color="info"
                                          title=" Mail"
                                          onClick={() =>
                                            window.open(
                                              `mailto:${data?.lead_info?.probate?.lead_info?.PetitionerEmails}`
                                            )
                                          }
                                        >
                                          <FontAwesomeIcon
                                            icon={faEnvelope}
                                            size="1x"
                                          />
                                        </Button>
                                      )}
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    )}
                    {/* ========Attorney is=============== */}
                    {data?.lead_info?.probate && (recordId || addressId) && (
                      <Row>
                        <Col md="12">
                          <Card className="main-card mb-1">
                            <CardBody>
                              <CardTitle></CardTitle>

                              <Row>
                                <Col md="5">
                                  <h4 className="text-primary m-0 text-center">
                                    Attornery
                                  </h4>
                                  <h4
                                    className="text-center"
                                    style={{ color: "#003333" }}
                                  >
                                    {data?.lead_info?.probate?.lead_info
                                      ?.AttorneyFullName || ""}
                                  </h4>

                                  <p className="text-center">
                                    {data?.lead_info?.probate?.lead_info
                                      ?.AttorneyAddress || ""}
                                    <br />{" "}
                                    {
                                      data?.lead_info?.probate?.lead_info
                                        ?.AttorneyCity
                                    }
                                    ,{" "}
                                    {
                                      data?.lead_info?.probate?.lead_info
                                        ?.AttorneyState
                                    }{" "}
                                    {
                                      data?.lead_info?.probate?.lead_info
                                        ?.AttorneyZip
                                    }
                                  </p>
                                </Col>
                                <Col md="7">
                                  <Row>
                                    <Col xs="10" md="9">
                                      <h5 className="fw-bold">Phone number</h5>{" "}
                                    </Col>
                                    <Col xs="2" md="3">
                                      {/* <Button
                                    color="link"
                                    onClick={() => setAttorCustom1(!attorCustom1)}
                                  >
                                    ADD
                                  </Button> */}
                                    </Col>
                                  </Row>
                                  <Collapse isOpen={attorCustom1}>
                                    <div className="mb-3 m-0 p-0">
                                      <Row>
                                        <Col md="12">
                                          <Input
                                            type="email"
                                            className="mt-1"
                                            placeholder="(999) 999-9999"
                                          />
                                          <FormFeedback>
                                            Please input a complete correct
                                            phone number.
                                          </FormFeedback>
                                          <FormFeedback valid>
                                            That's a correct phone number you've
                                            entered there.
                                          </FormFeedback>
                                        </Col>
                                        <Col md="12">
                                          <Input type="select" className="mt-2">
                                            <option>Unknown</option>
                                            <option>Landline</option>
                                            <option>Mobile</option>
                                            <option>VoIP</option>
                                          </Input>
                                        </Col>

                                        <Col md="12" className="mt-2">
                                          <DropdownList
                                            defaultValue="Red"
                                            renderListItem={renderColor}
                                            data={[
                                              "Red",
                                              "Yellow",
                                              "Blue",
                                              "Orange",
                                            ]}
                                            renderValue={customRenderValue}
                                          />
                                        </Col>

                                        <Col md="6" className="mt-2">
                                          <Button
                                            block
                                            outline
                                            className=" btn-wide mb-2 me-2 btn-transition"
                                            color="secondary"
                                            onClick={() =>
                                              setAttorCustom1(!attorCustom1)
                                            }
                                          >
                                            Cancel
                                          </Button>
                                        </Col>
                                        <Col md="6" className="mt-2">
                                          <Button
                                            block
                                            disabled
                                            outline
                                            className="btn-wide mb-2 me-2 btn-transition"
                                            color="primary"
                                          >
                                            Add
                                          </Button>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Collapse>

                                  <Row className="g-1">
                                    <Col xs="10">
                                      {data?.lead_info?.probate?.lead_info
                                        ?.AttorneyPhones || ""}
                                    </Col>
                                    <Col xs="2">
                                      {data?.lead_info?.probate?.lead_info
                                        ?.AttorneyPhones && (
                                        <Button
                                          className="border-0 btn-transition"
                                          outline
                                          color="success"
                                          title=" Call"
                                          onClick={() =>
                                            (window.location.href = `tel:${data?.lead_info?.probate?.lead_info?.AttorneyPhones}`)
                                          }
                                        >
                                          <FontAwesomeIcon
                                            icon={faPhone}
                                            size="1x"
                                          />
                                        </Button>
                                      )}
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col xs="10" md="9">
                                      <h5 className="fw-bold mt-3">Emails </h5>
                                    </Col>
                                    <Col xs="2" md="3" className="mt-2">
                                      {/* <Button
                                    className=" "
                                    color="link"
                                    onClick={() => setAttorCustom2(!attorCustom2)}
                                  >
                                    ADD
                                  </Button> */}
                                    </Col>
                                  </Row>
                                  <Collapse isOpen={attorCustom2}>
                                    <div className="mb-3">
                                      <Row>
                                        <Col md="12" className="mt-2">
                                          <Input
                                            type="email"
                                            placeholder="email@exmaple.com"
                                          />
                                          <FormFeedback>
                                            Please input a complete correct
                                            email.
                                          </FormFeedback>
                                          <FormFeedback valid>
                                            That's a tasty looking email you've
                                            got there.
                                          </FormFeedback>
                                        </Col>
                                        <Col md="6" className="mt-2">
                                          <Button
                                            block
                                            outline
                                            className=" btn-wide mb-2 me-2 btn-transition"
                                            color="secondary"
                                            onClick={() =>
                                              setAttorCustom2(!attorCustom2)
                                            }
                                          >
                                            Cancel
                                          </Button>
                                        </Col>
                                        <Col md="6" className="mt-2">
                                          <Button
                                            disabled
                                            block
                                            outline
                                            className="btn-wide mb-2 me-2 btn-transition"
                                            color="primary"
                                          >
                                            Add
                                          </Button>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Collapse>

                                  <Row className="g-1">
                                    <Col xs="10">
                                      {data?.lead_info?.probate?.lead_info
                                        ?.AttorneyEmails || ""}
                                    </Col>
                                    <Col xs="2">
                                      {data?.lead_info?.probate?.lead_info
                                        ?.AttorneyEmails && (
                                        <Button
                                          className="border-0 btn-transition"
                                          outline
                                          color="info"
                                          title=" Mail"
                                          onClick={() =>
                                            window.open(
                                              `mailto:${data?.lead_info?.probate?.lead_info?.AttorneyEmails}`
                                            )
                                          }
                                        >
                                          <FontAwesomeIcon
                                            icon={faEnvelope}
                                            size="1x"
                                          />
                                        </Button>
                                      )}
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    )}
                    {/* new rows added on top of this */}
                    <Row>
                      {Object.keys(data).filter((key) => key !== "people")
                        .length === 0 || !addressId ? (
                        <>
                          {data?.people?.map((v, index) => (
                            <Col md="12" className="mb-1" key={index}>
                              <Card className="main-card mb-1">
                                <CardBody>
                                  <CardTitle></CardTitle>
                                  <Row>
                                    <Col md="12" className="mb-4">
                                      {data?.people?.length > 1 && (
                                        <Button
                                          className=" me-3 mb-1 border-0 btn-transition position-absolute end-0"
                                          outline
                                          color="danger"
                                          title=" Cancel"
                                          onClick={() => removePeople(index)}
                                        >
                                          <FontAwesomeIcon
                                            icon={faMinusCircle}
                                            size="1x"
                                          />
                                        </Button>
                                      )}
                                    </Col>
                                    <Col md="6">
                                      <Row>
                                        <Col md={12}>
                                          <FormGroup>
                                            {/* <Label className="fw-bold">Person type</Label> */}
                                            <Input
                                              value={v?.title}
                                              onChange={(e) =>
                                                handlePerson(
                                                  "title",
                                                  e.target.value,
                                                  index
                                                )
                                              }
                                              type="select"
                                              placeholder="Person Type"
                                            >
                                              <option value="">
                                                Person Type
                                              </option>
                                              <option value="CashBuyer">
                                                CashBuyer
                                              </option>
                                              <option value="Seller">
                                                Seller
                                              </option>
                                              <option value="Decedent">
                                                Decedent
                                              </option>
                                              <option value="Petitioner/PR">
                                                Petitioner/PR
                                              </option>
                                              <option value="Attorney">
                                                Attorney
                                              </option>
                                              <option value="Relative">
                                                Relative
                                              </option>
                                            </Input>
                                          </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                          <FormGroup>
                                            {/* <Label className="fw-bold">First Name</Label> */}
                                            <Input
                                              value={v?.first_name}
                                              onChange={(e) =>
                                                handlePerson(
                                                  "first_name",
                                                  e.target.value,
                                                  index
                                                )
                                              }
                                              type="text"
                                              placeholder="First Name"
                                            />
                                          </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                          <FormGroup>
                                            {/* <Label className="fw-bold">Middle Name</Label> */}
                                            <Input
                                              value={v?.middle_name}
                                              onChange={(e) =>
                                                handlePerson(
                                                  "middle_name",
                                                  e.target.value,
                                                  index
                                                )
                                              }
                                              type="text"
                                              placeholder="Middle Name"
                                            />
                                          </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                          <FormGroup>
                                            {/* <Label className="fw-bold">Last Name</Label> */}
                                            <Input
                                              value={v?.last_name}
                                              onChange={(e) =>
                                                handlePerson(
                                                  "last_name",
                                                  e.target.value,
                                                  index
                                                )
                                              }
                                              type="text"
                                              placeholder="Last Name"
                                            />
                                          </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                          <FormGroup>
                                            {/* <Label className="fw-bold">Suffix</Label> */}
                                            <Input
                                              value={v?.suffix}
                                              onChange={(e) =>
                                                handlePerson(
                                                  "suffix",
                                                  e.target.value,
                                                  index
                                                )
                                              }
                                              type="text"
                                              placeholder="Suffix"
                                            />
                                          </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                          <FormGroup>
                                            {/* <Label className="fw-bold">Suffix</Label> */}
                                            <Input
                                              value={v?.age}
                                              onChange={(e) =>
                                                handlePerson(
                                                  "age",
                                                  e.target.value,
                                                  index
                                                )
                                              }
                                              type="number"
                                              placeholder="Age"
                                            />
                                          </FormGroup>
                                        </Col>
                                        {v?.addresses?.map((add, index) => (
                                          <Row key={index}>
                                            <Col md={12}>
                                              <FormGroup>
                                                <Input
                                                  value={add?.address1}
                                                  onChange={(e) =>
                                                    handlePerson(
                                                      "addresses.address1",
                                                      e.target.value,
                                                      index
                                                    )
                                                  }
                                                  type="text"
                                                  placeholder="Address"
                                                />
                                                {/* <Label className="fw-bold">Mailing Address</Label> */}
                                                {/* <Combobox
                                          busy={busy}
                                          hideCaret
                                          hideEmptyPopup
                                          value={searchWord}
                                          filter='contains'
                                          dataKey="id" textField="get_email_search_results_for_cc"
                                          data={searchData}
                                          placeholder="Mailing Address"
                                          onChange={(val) => { searchCustomer(val); setSearchWord(val) }}
                                        /> */}
                                              </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                              <FormGroup>
                                                {/* <Label className="fw-bold">City</Label> */}
                                                <Input
                                                  value={add?.city}
                                                  onChange={(e) =>
                                                    handlePerson(
                                                      "addresses.city",
                                                      e.target.value,
                                                      index
                                                    )
                                                  }
                                                  type="text"
                                                  placeholder="City"
                                                />
                                              </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                              <FormGroup>
                                                {/* <Label className="fw-bold">State</Label> */}
                                                <Input
                                                  value={add?.state}
                                                  onChange={(e) =>
                                                    handlePerson(
                                                      "addresses.state",
                                                      e.target.value,
                                                      index
                                                    )
                                                  }
                                                  type="text"
                                                  placeholder="State"
                                                />
                                              </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                              <FormGroup>
                                                {/* <Label className="fw-bold">Zip Code</Label> */}
                                                <Input
                                                  value={add?.zip}
                                                  onChange={(e) =>
                                                    handlePerson(
                                                      "addresses.zip",
                                                      e.target.value,
                                                      index
                                                    )
                                                  }
                                                  type="number"
                                                  placeholder="Zip"
                                                />
                                              </FormGroup>
                                            </Col>
                                          </Row>
                                        ))}
                                      </Row>
                                    </Col>
                                    <Col md="6">
                                      <Row>
                                        <Col xs="10" md="9">
                                          <h5 className="fw-bold">
                                            Phone number
                                          </h5>{" "}
                                        </Col>
                                        <Col xs="2" md="3">
                                          <Button color="link">ADD</Button>
                                        </Col>
                                      </Row>
                                      <Row className="mt-5">
                                        <Col xs="10" md="9">
                                          <h5 className="fw-bold">Email</h5>{" "}
                                        </Col>
                                        <Col xs="2" md="3">
                                          <Button color="link">ADD</Button>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          ))}
                          {data?.people?.length <= 9 && (
                            <>
                              <Col xs="1" className="mt-2"></Col>
                              <Col xs="10" className="mt-2">
                                <Button
                                  className="border btn-transition p-3"
                                  outline
                                  block
                                  color="secondary"
                                  onClick={addPeople}
                                >
                                  + Add Person Type
                                </Button>
                              </Col>
                              <Col xs="1" className="mt-2"></Col>
                            </>
                          )}
                        </>
                      ) : (
                        <Col md="12">
                          <Card className="main-card mb-1">
                            <CardBody>
                              <CardTitle></CardTitle>
                              <Row>
                                <Col md="5" style={{ marginBottom: "0.5rem" }}>
                                  <h4 className="text-primary m-0 text-center">
                                    {data?.lead_info?.probate
                                      ? "Deceased"
                                      : "Owner1"}
                                  </h4>

                                  <h3
                                    className="text-center"
                                    style={{ color: "#003333" }}
                                  >
                                    {data?.owner_first_name || "-"}{" "}
                                    {data?.owner_last_name || "-"}
                                  </h3>

                                  <h6 className="text-center">
                                    {data?.mailing_number || "-"}{" "}
                                    {data?.mailing_street}, <br />
                                    {data?.mailing_city}, {data?.mailing_state}{" "}
                                    {data?.mailing_zip}
                                  </h6>
                                </Col>
                                <Col md="7">
                                  <Row>
                                    <Col xs="10" md="9">
                                      <h5 className="fw-bold">Phone number</h5>{" "}
                                    </Col>
                                    <Col xs="2" md="3">
                                      <Button
                                        color="link"
                                        onClick={() => {
                                          setCustom(!custom);
                                          setBtn("Add");
                                        }}
                                      >
                                        ADD
                                      </Button>
                                    </Col>
                                  </Row>

                                  <Collapse isOpen={custom}>
                                    <div className="mb-3 m-0 p-0">
                                      <Row>
                                        <Col md="12">
                                          <InputMask
                                            className="form-control"
                                            mask="(999) 999-9999"
                                            placeholder="(123) 456-7890"
                                            maskChar={null}
                                            value={phoneData.phone_number || ""}
                                            onChange={(e) =>
                                              handleChange2(
                                                e.target.value,
                                                "phone_number"
                                              )
                                            }
                                          />
                                          <div
                                            style={
                                              phoneValidate?.hasErrors
                                                ? { display: "block" }
                                                : { display: "none" }
                                            }
                                            className="invalid-feedback"
                                          >
                                            {phoneValidate?.phone_number}
                                          </div>
                                          <div
                                            style={
                                              !phoneValidate.hasErrors
                                                ? { display: "block" }
                                                : { display: "none" }
                                            }
                                            className="valid-feedback"
                                          >
                                            {phoneValidate?.phone_number}
                                          </div>
                                        </Col>
                                        <Col md="12">
                                          <Input
                                            type="select"
                                            className="mt-2"
                                            value={phoneData.phone_type || " "}
                                            onChange={(e) =>
                                              handleChange2(
                                                e.target.value,
                                                "phone_type"
                                              )
                                            }
                                          >
                                            <option>Unknown</option>
                                            <option>Landline</option>
                                            <option>Mobile</option>
                                            <option>VoIP</option>
                                          </Input>
                                        </Col>

                                        <Col md="12" className="mt-2">
                                          <Input
                                            type="select"
                                            className="mt-2"
                                            value={
                                              phoneData.phone_status || " "
                                            }
                                            onChange={(e) =>
                                              handleChange2(
                                                e.target.value,
                                                "phone_status"
                                              )
                                            }
                                          >
                                            {" "}
                                            <option
                                              value=""
                                              disabled={
                                                !!phoneData.phone_status
                                              }
                                            >
                                              Phone Status
                                            </option>
                                            <option>Good</option>
                                            <option>Contacted</option>
                                            <option>Wrong Person</option>
                                            <option>Disconnected</option>
                                            <option>No Answer</option>
                                            <option>DNC</option>
                                            <option>Left VM</option>
                                          </Input>
                                        </Col>

                                        <Col md="6" className="mt-2">
                                          <Button
                                            block
                                            outline
                                            className=" btn-wide mb-2 me-2 btn-transition"
                                            color="secondary"
                                            onClick={() => phoneValueCancel()}
                                          >
                                            Cancel
                                          </Button>
                                        </Col>
                                        <Col md="6" className="mt-2">
                                          <Button
                                            block
                                            outline
                                            className="btn-wide mb-2 me-2 btn-transition"
                                            color="primary"
                                            onClick={addUpdatePhone}
                                          >
                                            {phoneRequesting ? (
                                              <>
                                                <Spinner size="sm" />
                                                <span className="mb-2">
                                                  {" "}
                                                  {btn}ing
                                                </span>{" "}
                                              </>
                                            ) : (
                                              btn
                                            )}
                                          </Button>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Collapse>
                                  {/* <Collapse isOpen={custom3}>
                                <div className="mb-3 m-0 p-0">
                                  <Row>
                                    <Col md="12">
                                      <Input
                                        type="text"
                                        placeholder="(999) 999-9999"
                                        className="mt-1 border border-primary"
                                      //   
                                      />
                                    </Col>
                                    <Col md="12" className="mt-2">
                                      <Input
                                        type="select"
                                        className="mt-2"
                                      > <option>Phone Status</option>
                                        <option>Good</option>
                                        <option>Wrong Person</option>
                                        <option>Disconnected</option>
                                        <option>No Answer</option>
                                        <option>DNC</option>
                                        <option>VM</option>
                                      </Input>
                                    </Col>

                                    <Col md="6" className="mt-2">
                                      <Button
                                        block
                                        outline
                                        className=" btn-wide mb-2 me-2 btn-transition"
                                        color="secondary"
                                        onClick={() =>
                                          setCustom3(!custom3)
                                        }
                                      >
                                        Cancel
                                      </Button>
                                    </Col>
                                    <Col md="6" className="mt-2">
                                      <Button
                                        block
                                        outline
                                        className="btn-wide mb-2 me-2 btn-transition"
                                        color="primary"
                                        onClick={updatePhone}
                                      >
                                        Update
                                      </Button>
                                    </Col>
                                  </Row>
                                </div>
                              </Collapse> */}
                                  {phone?.map((ph, key) => {
                                    return (
                                      <Row key={key} className="g-0">
                                        <Col xs="7" className="mt-1">
                                          {ph?.phone || "none"}
                                        </Col>
                                        <Col xs="5">
                                          {ph?.user_defined !== 1 ? (
                                            <Button
                                              className="border-0 btn-transition"
                                              outline
                                              color="success"
                                              title=" Call"
                                              onClick={() =>
                                                (window.location.href = `tel:${ph?.phone}`)
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faPhone}
                                                size="1x"
                                              />
                                            </Button>
                                          ) : (
                                            <div>
                                              <Button
                                                className="border-0 btn-transition"
                                                outline
                                                color="primary"
                                                onClick={() => {
                                                  setCustom(!custom);
                                                  setBtn("Edit");
                                                  setPhoneData({
                                                    ...state1,
                                                    phone_number: ph?.phone,
                                                    old_phone_no: ph?.phone,
                                                    phone_type: ph?.type,
                                                    phone_status: ph?.status,
                                                  });
                                                }}
                                                title=" Edit"
                                              >
                                                <FontAwesomeIcon
                                                  icon={faPen}
                                                  size="1x"
                                                />
                                              </Button>
                                              <Button
                                                className="border-0 btn-transition"
                                                outline
                                                color="danger"
                                                onClick={() => {
                                                  setAlert1(true);
                                                  setSpecificPhone(ph?.phone);
                                                }}
                                                title=" Delete"
                                              >
                                                <FontAwesomeIcon
                                                  icon={faTrashAlt}
                                                  size="1x"
                                                />
                                              </Button>
                                              <Button
                                                className="border-0 btn-transition"
                                                outline
                                                color="success"
                                                title=" Call"
                                                onClick={() =>
                                                  (window.location.href = `tel:${ph?.phone}`)
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={faPhone}
                                                  size="1x"
                                                />
                                              </Button>
                                              {/* <Col xs="5" md='3' id={`Popoverdetail${key + 1}`}>
                                            <div className="swatch-holder swatch-holder-sm bg-danger" role="button" onClick={() => handleCollase(ph?.phone)} title="Detail Info" />
                                            <Popover className="rm-max-width" placement="bottom" fade={false} trigger="legacy"
                                              isOpen={open[ph?.phone]} target={`Popoverdetail${key + 1}`} toggle={() => handleCollase(ph?.phone)}>
                                              <div className="p-0">
                                                <div className="dropdown-menu-header m-0">
                                                  <div className="dropdown-menu-header-inner bg-premium-dark">
                                                    <div className="menu-header-image"
                                                      style={{
                                                        backgroundImage: "url(" + bg4 + ")",
                                                      }} />
                                                    <div className="menu-header-content text-white">
                                                      <h6 className="menu-header-subtitle">
                                                        status for {ph?.phone}
                                                      </h6>
                                                    </div>
                                                  </div>
                                                </div>
                                                <Row className="m-1">
                                                  <Col md="12" className="mt-2">
                                                    <DropdownList
                                                      defaultValue="Red"
                                                      renderListItem={renderColor}
                                                      data={["Red", "Yellow", "Blue", "Orange"]}
                                                      renderValue={customRenderValue}
                                                      onChange={() => handleCollase(ph?.phone)}
                                                    />
                                                  </Col>
                                                </Row>
                                              </div>
                                            </Popover>

                                          </Col> */}
                                            </div>
                                          )}
                                        </Col>
                                      </Row>
                                    );
                                  })}
                                  {alert1 && (
                                    <Portal id="sweet-alert-portal">
                                      <SweetAlert
                                        r
                                        title="Are you sure?"
                                        show={alert1}
                                        type="danger"
                                        onConfirm={deletePhone}
                                        onCancel={() => setAlert1(false)}
                                        showCancel
                                        confirmBtnText={
                                          deleteRequesting ? (
                                            <>
                                              <Spinner size="sm" />
                                              <span className="mb-2">
                                                {" "}
                                                Deleting
                                              </span>{" "}
                                            </>
                                          ) : (
                                            "Yes, delete it!"
                                          )
                                        }
                                        confirmBtnBsStyle="danger"
                                        cancelBtnBsStyle="info"
                                      />
                                    </Portal>
                                  )}

                                  <Row>
                                    <Col xs="10" md="9">
                                      <h5 className="fw-bold mt-3">Emails </h5>
                                    </Col>
                                    <Col xs="2" md="3" className="mt-3">
                                      <Button
                                        className=" "
                                        color="link"
                                        onClick={() => {
                                          setCustom2(!custom2);
                                          setBtn("Add");
                                        }}
                                      >
                                        ADD
                                      </Button>
                                    </Col>
                                  </Row>

                                  <Collapse isOpen={custom2}>
                                    <div className="mb-3">
                                      <Row>
                                        <Col md="12" className="mt-2">
                                          <Input
                                            type="email"
                                            value={emailData.email || " "}
                                            valid={
                                              emailValidate.validate ===
                                              "has-success"
                                            }
                                            invalid={
                                              emailValidate.validate ===
                                              "has-danger"
                                            }
                                            placeholder="email@exmaple.com"
                                            onChange={(e) =>
                                              handleChange1(
                                                e.target.value,
                                                "email"
                                              )
                                            }
                                          />
                                          <Col md="12">
                                            <Input
                                              type="select"
                                              className="mt-2"
                                              // value={phoneData.phone_type || " "}
                                              // onChange={(e) =>
                                              //   handleChange2(
                                              //     e.target.value,
                                              //     "phone_type"
                                              //   )
                                              // }
                                            >
                                              <option>Not Verified</option>
                                              <option>Verified</option>
                                              <option>
                                                Verified, Contacted
                                              </option>
                                              <option>Do not contact</option>
                                            </Input>
                                          </Col>
                                          <FormFeedback>
                                            Please input a complete correct
                                            email.
                                          </FormFeedback>
                                          <FormFeedback valid>
                                            That's a tasty looking email you've
                                            got there.
                                          </FormFeedback>
                                        </Col>
                                        <Col md="6" className="mt-2">
                                          <Button
                                            block
                                            outline
                                            className=" btn-wide mb-2 me-2 btn-transition"
                                            color="secondary"
                                            onClick={() => emailValueCancel()}
                                          >
                                            Cancel
                                          </Button>
                                        </Col>
                                        <Col md="6" className="mt-2">
                                          <Button
                                            block
                                            outline
                                            className="btn-wide mb-2 me-2 btn-transition"
                                            color="primary"
                                            onClick={addUpdateEmail}
                                          >
                                            {emailRequesting ? (
                                              <>
                                                <Spinner size="sm" />
                                                <span className="mb-2">
                                                  {" "}
                                                  {btn}ing
                                                </span>{" "}
                                              </>
                                            ) : (
                                              btn
                                            )}
                                          </Button>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Collapse>

                                  {email?.map((ph, key) => {
                                    return (
                                      <Row key={key} className="g-0">
                                        <Col xs="7">{ph?.email || "none"}</Col>
                                        <Col xs="5">
                                          {ph?.user_defined !== 1 ? (
                                            <Button
                                              className="border-0 btn-transition"
                                              outline
                                              color="info"
                                              title="Mail"
                                              onClick={() =>
                                                window.open(
                                                  `mailto:${ph?.email}`
                                                )
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faEnvelope}
                                                size="1x"
                                              />
                                            </Button>
                                          ) : (
                                            <div className="text-danger">
                                              <Button
                                                className="border-0 btn-transition"
                                                outline
                                                color="primary"
                                                onClick={() => {
                                                  setCustom2(!custom2);
                                                  setBtn("Edit");
                                                  setEmailData({
                                                    ...state2,
                                                    email: ph?.email,
                                                    old_email: ph?.email,
                                                  });
                                                }}
                                                title=" Edit"
                                              >
                                                <FontAwesomeIcon
                                                  icon={faPen}
                                                  size="1x"
                                                />
                                              </Button>
                                              <Button
                                                className="border-0 btn-transition"
                                                outline
                                                color="danger"
                                                onClick={() => {
                                                  setAlert2(true);
                                                  setSpecificEmail(ph?.email);
                                                }}
                                                title=" Delete"
                                              >
                                                <FontAwesomeIcon
                                                  icon={faTrashAlt}
                                                  size="1x"
                                                />
                                              </Button>
                                              <Button
                                                className="border-0 btn-transition"
                                                outline
                                                color="info"
                                                title=" Mail"
                                                onClick={() =>
                                                  window.open(
                                                    `mailto:${ph?.email}`
                                                  )
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={faEnvelope}
                                                  size="1x"
                                                />
                                              </Button>
                                            </div>
                                          )}
                                        </Col>
                                      </Row>
                                    );
                                  })}

                                  {alert2 && (
                                    <Portal id="sweet-alert-portal">
                                      <SweetAlert
                                        title="Are you sure?"
                                        show={alert2}
                                        type="danger"
                                        onConfirm={deleteEmail}
                                        onCancel={() => setAlert2(false)}
                                        showCancel
                                        confirmBtnText={
                                          deleteRequesting ? (
                                            <>
                                              <Spinner size="sm" />
                                              <span className="mb-2">
                                                {" "}
                                                Deleting
                                              </span>{" "}
                                            </>
                                          ) : (
                                            "Yes, delete it!"
                                          )
                                        }
                                        confirmBtnBsStyle="danger"
                                        cancelBtnBsStyle="info"
                                      />
                                    </Portal>
                                  )}
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>

                          {data?.owner2?.first_name && (
                            <Card className="main-card mb-1">
                              <CardBody>
                                <CardTitle></CardTitle>
                                <Row>
                                  <Col md="5" className="text-center">
                                    <Row className="g-0">
                                      <Col md="12">
                                        <h4 className="text-primary m-0 text-center">
                                          Owner 2
                                        </h4>
                                      </Col>
                                      <Col md="12">
                                        <h3 style={{ color: "#003333" }}>
                                          {data?.owner2_first_name || ""}{" "}
                                          {data?.owner2_middle_name || ""}{" "}
                                          {data?.owner2_last_name || ""}{" "}
                                          {data?.owner2_suffix || ""}
                                        </h3>
                                      </Col>
                                      <Col md="6">
                                        <p>
                                          <b>AGE:</b> {data?.owner2_age || "-"}
                                        </p>
                                      </Col>
                                      <Col md="6">
                                        {" "}
                                        <p>
                                          <b>Type:</b>{" "}
                                          {data?.owner2_type || "-"}
                                        </p>
                                      </Col>
                                      <Col md="12">
                                        <p>
                                          <b>Property Count:</b>{" "}
                                          {data?.owner2_property_count || "-"}
                                        </p>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="7">
                                    <Row>
                                      <Col xs="10" md="9">
                                        <h5 className="fw-bold">
                                          Phone number
                                        </h5>{" "}
                                      </Col>
                                      <Col xs="2" md="3">
                                        <Button
                                          color="link"
                                          onClick={() => {
                                            setCustom(!custom);
                                            setBtn("Add");
                                          }}
                                        >
                                          ADD
                                        </Button>
                                      </Col>
                                    </Row>

                                    <Collapse isOpen={custom}>
                                      <div className="mb-3 m-0 p-0">
                                        <Row>
                                          <Col md="12">
                                            <InputMask
                                              className="form-control"
                                              mask="(999) 999-9999"
                                              placeholder="(123) 456-7890"
                                              maskChar={null}
                                              value={
                                                phoneData.phone_number || ""
                                              }
                                              onChange={(e) =>
                                                handleChange2(
                                                  e.target.value,
                                                  "phone_number"
                                                )
                                              }
                                            />
                                            <div
                                              style={
                                                phoneValidate?.hasErrors
                                                  ? { display: "block" }
                                                  : { display: "none" }
                                              }
                                              className="invalid-feedback"
                                            >
                                              {phoneValidate?.phone_number}
                                            </div>
                                            <div
                                              style={
                                                !phoneValidate.hasErrors
                                                  ? { display: "block" }
                                                  : { display: "none" }
                                              }
                                              className="valid-feedback"
                                            >
                                              {phoneValidate?.phone_number}
                                            </div>
                                          </Col>
                                          <Col md="12">
                                            <Input
                                              type="select"
                                              className="mt-2"
                                              value={
                                                phoneData.phone_type || " "
                                              }
                                              onChange={(e) =>
                                                handleChange2(
                                                  e.target.value,
                                                  "phone_type"
                                                )
                                              }
                                            >
                                              <option>Unknown</option>
                                              <option>Landline</option>
                                              <option>Mobile</option>
                                              <option>VoIP</option>
                                            </Input>
                                          </Col>

                                          <Col md="12" className="mt-2">
                                            <Input
                                              type="select"
                                              className="mt-2"
                                              value={
                                                phoneData.phone_status || " "
                                              }
                                              onChange={(e) =>
                                                handleChange2(
                                                  e.target.value,
                                                  "phone_status"
                                                )
                                              }
                                            >
                                              {" "}
                                              <option
                                                value=""
                                                disabled={
                                                  !!phoneData.phone_status
                                                }
                                              >
                                                Phone Status
                                              </option>
                                              <option>Good</option>
                                              <option>Contacted</option>
                                              <option>Wrong Person</option>
                                              <option>Disconnected</option>
                                              <option>No Answer</option>
                                              <option>DNC</option>
                                              <option>Left VM</option>
                                            </Input>
                                          </Col>

                                          <Col md="6" className="mt-2">
                                            <Button
                                              block
                                              outline
                                              className=" btn-wide mb-2 me-2 btn-transition"
                                              color="secondary"
                                              onClick={() => phoneValueCancel()}
                                            >
                                              Cancel
                                            </Button>
                                          </Col>
                                          <Col md="6" className="mt-2">
                                            <Button
                                              block
                                              outline
                                              className="btn-wide mb-2 me-2 btn-transition"
                                              color="primary"
                                              onClick={addUpdatePhone}
                                            >
                                              {phoneRequesting ? (
                                                <>
                                                  <Spinner size="sm" />
                                                  <span className="mb-2">
                                                    {" "}
                                                    {btn}ing
                                                  </span>{" "}
                                                </>
                                              ) : (
                                                btn
                                              )}
                                            </Button>
                                          </Col>
                                        </Row>
                                      </div>
                                    </Collapse>
                                    {phone?.map((ph, key) => {
                                      return (
                                        <Row key={key} className="g-0">
                                          <Col xs="7" className="mt-1">
                                            {ph?.phone || "none"}
                                          </Col>
                                          <Col xs="5">
                                            {ph?.user_defined !== 1 ? (
                                              <Button
                                                className="border-0 btn-transition"
                                                outline
                                                color="success"
                                                title=" Call"
                                                onClick={() =>
                                                  (window.location.href = `tel:${ph?.phone}`)
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={faPhone}
                                                  size="1x"
                                                />
                                              </Button>
                                            ) : (
                                              <div>
                                                <Button
                                                  className="border-0 btn-transition"
                                                  outline
                                                  color="primary"
                                                  onClick={() => {
                                                    setCustom(!custom);
                                                    setBtn("Edit");
                                                    setPhoneData({
                                                      ...state1,
                                                      phone_number: ph?.phone,
                                                      old_phone_no: ph?.phone,
                                                      phone_type: ph?.type,
                                                      phone_status: ph?.status,
                                                    });
                                                  }}
                                                  title=" Edit"
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faPen}
                                                    size="1x"
                                                  />
                                                </Button>
                                                <Button
                                                  className="border-0 btn-transition"
                                                  outline
                                                  color="danger"
                                                  onClick={() => {
                                                    setAlert1(true);
                                                    setSpecificPhone(ph?.phone);
                                                  }}
                                                  title=" Delete"
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faTrashAlt}
                                                    size="1x"
                                                  />
                                                </Button>
                                                <Button
                                                  className="border-0 btn-transition"
                                                  outline
                                                  color="success"
                                                  title=" Call"
                                                  onClick={() =>
                                                    (window.location.href = `tel:${ph?.phone}`)
                                                  }
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faPhone}
                                                    size="1x"
                                                  />
                                                </Button>
                                              </div>
                                            )}
                                          </Col>
                                        </Row>
                                      );
                                    })}
                                    {alert1 && (
                                      <Portal id="sweet-alert-portal">
                                        <SweetAlert
                                          r
                                          title="Are you sure?"
                                          show={alert1}
                                          type="danger"
                                          onConfirm={deletePhone}
                                          onCancel={() => setAlert1(false)}
                                          showCancel
                                          confirmBtnText={
                                            deleteRequesting ? (
                                              <>
                                                <Spinner size="sm" />
                                                <span className="mb-2">
                                                  {" "}
                                                  Deleting
                                                </span>{" "}
                                              </>
                                            ) : (
                                              "Yes, delete it!"
                                            )
                                          }
                                          confirmBtnBsStyle="danger"
                                          cancelBtnBsStyle="info"
                                        />
                                      </Portal>
                                    )}

                                    <Row>
                                      <Col xs="10" md="9">
                                        <h5 className="fw-bold mt-3">
                                          Emails{" "}
                                        </h5>
                                      </Col>
                                      <Col xs="2" md="3" className="mt-3">
                                        <Button
                                          className=" "
                                          color="link"
                                          onClick={() => {
                                            setCustom2(!custom2);
                                            setBtn("Add");
                                          }}
                                        >
                                          ADD
                                        </Button>
                                      </Col>
                                    </Row>

                                    <Collapse isOpen={custom2}>
                                      <div className="mb-3">
                                        <Row>
                                          <Col md="12" className="mt-2">
                                            <Input
                                              type="email"
                                              value={emailData.email || " "}
                                              valid={
                                                emailValidate.validate ===
                                                "has-success"
                                              }
                                              invalid={
                                                emailValidate.validate ===
                                                "has-danger"
                                              }
                                              placeholder="email@exmaple.com"
                                              onChange={(e) =>
                                                handleChange1(
                                                  e.target.value,
                                                  "email"
                                                )
                                              }
                                            />
                                            <Col md="12">
                                              <Input
                                                type="select"
                                                className="mt-2"
                                              >
                                                <option>Not Verified</option>
                                                <option>Verified</option>
                                                <option>
                                                  Verified, Contacted
                                                </option>
                                                <option>Do not contact</option>
                                              </Input>
                                            </Col>
                                            <FormFeedback>
                                              Please input a complete correct
                                              email.
                                            </FormFeedback>
                                            <FormFeedback valid>
                                              That's a tasty looking email
                                              you've got there.
                                            </FormFeedback>
                                          </Col>
                                          <Col md="6" className="mt-2">
                                            <Button
                                              block
                                              outline
                                              className=" btn-wide mb-2 me-2 btn-transition"
                                              color="secondary"
                                              onClick={() => emailValueCancel()}
                                            >
                                              Cancel
                                            </Button>
                                          </Col>
                                          <Col md="6" className="mt-2">
                                            <Button
                                              block
                                              outline
                                              className="btn-wide mb-2 me-2 btn-transition"
                                              color="primary"
                                              onClick={addUpdateEmail}
                                            >
                                              {emailRequesting ? (
                                                <>
                                                  <Spinner size="sm" />
                                                  <span className="mb-2">
                                                    {" "}
                                                    {btn}ing
                                                  </span>{" "}
                                                </>
                                              ) : (
                                                btn
                                              )}
                                            </Button>
                                          </Col>
                                        </Row>
                                      </div>
                                    </Collapse>

                                    {email?.map((ph, key) => {
                                      return (
                                        <Row key={key} className="g-0">
                                          <Col xs="7">
                                            {ph?.email || "none"}
                                          </Col>
                                          <Col xs="5">
                                            {ph?.user_defined !== 1 ? (
                                              <Button
                                                className="border-0 btn-transition"
                                                outline
                                                color="info"
                                                title="Mail"
                                                onClick={() =>
                                                  window.open(
                                                    `mailto:${ph?.email}`
                                                  )
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={faEnvelope}
                                                  size="1x"
                                                />
                                              </Button>
                                            ) : (
                                              <div className="text-danger">
                                                <Button
                                                  className="border-0 btn-transition"
                                                  outline
                                                  color="primary"
                                                  onClick={() => {
                                                    setCustom2(!custom2);
                                                    setBtn("Edit");
                                                    setEmailData({
                                                      ...state2,
                                                      email: ph?.email,
                                                      old_email: ph?.email,
                                                    });
                                                  }}
                                                  title=" Edit"
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faPen}
                                                    size="1x"
                                                  />
                                                </Button>
                                                <Button
                                                  className="border-0 btn-transition"
                                                  outline
                                                  color="danger"
                                                  onClick={() => {
                                                    setAlert2(true);
                                                    setSpecificEmail(ph?.email);
                                                  }}
                                                  title=" Delete"
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faTrashAlt}
                                                    size="1x"
                                                  />
                                                </Button>
                                                <Button
                                                  className="border-0 btn-transition"
                                                  outline
                                                  color="info"
                                                  title=" Mail"
                                                  onClick={() =>
                                                    window.open(
                                                      `mailto:${ph?.email}`
                                                    )
                                                  }
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faEnvelope}
                                                    size="1x"
                                                  />
                                                </Button>
                                              </div>
                                            )}
                                          </Col>
                                        </Row>
                                      );
                                    })}

                                    {alert2 && (
                                      <Portal id="sweet-alert-portal">
                                        <SweetAlert
                                          title="Are you sure?"
                                          show={alert2}
                                          type="danger"
                                          onConfirm={deleteEmail}
                                          onCancel={() => setAlert2(false)}
                                          showCancel
                                          confirmBtnText={
                                            deleteRequesting ? (
                                              <>
                                                <Spinner size="sm" />
                                                <span className="mb-2">
                                                  {" "}
                                                  Deleting
                                                </span>{" "}
                                              </>
                                            ) : (
                                              "Yes, delete it!"
                                            )
                                          }
                                          confirmBtnBsStyle="danger"
                                          cancelBtnBsStyle="info"
                                        />
                                      </Portal>
                                    )}
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          )}
                        </Col>
                      )}
                    </Row>
                  </>
                )}
                {data?.owner2_full_name && (
                  <Card className="main-card mb-1">
                    <CardBody>
                      <CardTitle></CardTitle>

                      <Row>
                        <Col md="5" className="text-center">
                          <Row className="g-0">
                            <Col md="12">
                              <h4 className="text-primary m-0 text-center">
                                Owner 2
                              </h4>
                            </Col>
                            <Col md="12">
                              <h3 style={{ color: "#003333" }}>
                                {data?.owner2_first_name || ""}{" "}
                                {data?.owner2_middle_name || ""}{" "}
                                {data?.owner2_last_name || ""}{" "}
                                {data?.owner2_suffix || ""}
                              </h3>
                            </Col>
                            <Col md="6">
                              <p>
                                <b>AGE:</b> {data?.owner2_age || "-"}
                              </p>
                            </Col>
                            <Col md="6">
                              {" "}
                              <p>
                                <b>Type:</b> {data?.owner2_type || "-"}
                              </p>
                            </Col>
                            <Col md="12">
                              <p>
                                <b>Property Count:</b>{" "}
                                {data?.owner2_property_count || "-"}
                              </p>
                            </Col>
                          </Row>
                        </Col>

                        <Col md="7">
                          <Row>
                            <Col xs="10" md="9">
                              <h5 className="fw-bold">Phone number</h5>{" "}
                            </Col>
                            <Col xs="2" md="3">
                              <Button
                                color="link"
                                onClick={() => {
                                  setCustom(!custom);
                                  setBtn("Add");
                                }}
                              >
                                ADD
                              </Button>
                            </Col>
                          </Row>

                          <Collapse isOpen={custom}>
                            <div className="mb-3 m-0 p-0">
                              <Row>
                                <Col md="12">
                                  <InputMask
                                    className="form-control"
                                    mask="(999) 999-9999"
                                    placeholder="(123) 456-7890"
                                    maskChar={null}
                                    value={phoneData.phone_number || ""}
                                    onChange={(e) =>
                                      handleChange2(
                                        e.target.value,
                                        "phone_number"
                                      )
                                    }
                                  />
                                  <div
                                    style={
                                      phoneValidate?.hasErrors
                                        ? { display: "block" }
                                        : { display: "none" }
                                    }
                                    className="invalid-feedback"
                                  >
                                    {phoneValidate?.phone_number}
                                  </div>
                                  <div
                                    style={
                                      !phoneValidate.hasErrors
                                        ? { display: "block" }
                                        : { display: "none" }
                                    }
                                    className="valid-feedback"
                                  >
                                    {phoneValidate?.phone_number}
                                  </div>
                                </Col>
                                <Col md="12">
                                  <Input
                                    type="select"
                                    className="mt-2"
                                    value={phoneData.phone_type || " "}
                                    onChange={(e) =>
                                      handleChange2(
                                        e.target.value,
                                        "phone_type"
                                      )
                                    }
                                  >
                                    <option>Unknown</option>
                                    <option>Landline</option>
                                    <option>Mobile</option>
                                    <option>VoIP</option>
                                  </Input>
                                </Col>

                                <Col md="12" className="mt-2">
                                  <Input
                                    type="select"
                                    className="mt-2"
                                    value={phoneData.phone_status || " "}
                                    onChange={(e) =>
                                      handleChange2(
                                        e.target.value,
                                        "phone_status"
                                      )
                                    }
                                  >
                                    {" "}
                                    <option
                                      value=""
                                      disabled={!!phoneData.phone_status}
                                    >
                                      Phone Status
                                    </option>
                                    <option>Good</option>
                                    <option>Contacted</option>
                                    <option>Wrong Person</option>
                                    <option>Disconnected</option>
                                    <option>No Answer</option>
                                    <option>DNC</option>
                                    <option>Left VM</option>
                                  </Input>
                                </Col>

                                <Col md="6" className="mt-2">
                                  <Button
                                    block
                                    outline
                                    className=" btn-wide mb-2 me-2 btn-transition"
                                    color="secondary"
                                    onClick={() => phoneValueCancel()}
                                  >
                                    Cancel
                                  </Button>
                                </Col>
                                <Col md="6" className="mt-2">
                                  <Button
                                    block
                                    outline
                                    className="btn-wide mb-2 me-2 btn-transition"
                                    color="primary"
                                    onClick={addUpdatePhone}
                                  >
                                    {phoneRequesting ? (
                                      <>
                                        <Spinner size="sm" />
                                        <span className="mb-2">
                                          {" "}
                                          {btn}ing
                                        </span>{" "}
                                      </>
                                    ) : (
                                      btn
                                    )}
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          </Collapse>
                          {phone?.map((ph, key) => {
                            return (
                              <Row key={key} className="g-0">
                                <Col xs="7" className="mt-1">
                                  {ph?.phone || "none"}
                                </Col>
                                <Col xs="5">
                                  {ph?.user_defined !== 1 ? (
                                    <Button
                                      className="border-0 btn-transition"
                                      outline
                                      color="success"
                                      title=" Call"
                                      onClick={() =>
                                        (window.location.href = `tel:${ph?.phone}`)
                                      }
                                    >
                                      <FontAwesomeIcon
                                        icon={faPhone}
                                        size="1x"
                                      />
                                    </Button>
                                  ) : (
                                    <div>
                                      <Button
                                        className="border-0 btn-transition"
                                        outline
                                        color="primary"
                                        onClick={() => {
                                          setCustom(!custom);
                                          setBtn("Edit");
                                          setPhoneData({
                                            ...state1,
                                            phone_number: ph?.phone,
                                            old_phone_no: ph?.phone,
                                            phone_type: ph?.type,
                                            phone_status: ph?.status,
                                          });
                                        }}
                                        title=" Edit"
                                      >
                                        <FontAwesomeIcon
                                          icon={faPen}
                                          size="1x"
                                        />
                                      </Button>
                                      <Button
                                        className="border-0 btn-transition"
                                        outline
                                        color="danger"
                                        onClick={() => {
                                          setAlert1(true);
                                          setSpecificPhone(ph?.phone);
                                        }}
                                        title=" Delete"
                                      >
                                        <FontAwesomeIcon
                                          icon={faTrashAlt}
                                          size="1x"
                                        />
                                      </Button>
                                      <Button
                                        className="border-0 btn-transition"
                                        outline
                                        color="success"
                                        title=" Call"
                                        onClick={() =>
                                          (window.location.href = `tel:${ph?.phone}`)
                                        }
                                      >
                                        <FontAwesomeIcon
                                          icon={faPhone}
                                          size="1x"
                                        />
                                      </Button>
                                    </div>
                                  )}
                                </Col>
                              </Row>
                            );
                          })}
                          {alert1 && (
                            <Portal id="sweet-alert-portal">
                              <SweetAlert
                                r
                                title="Are you sure?"
                                show={alert1}
                                type="danger"
                                onConfirm={deletePhone}
                                onCancel={() => setAlert1(false)}
                                showCancel
                                confirmBtnText={
                                  deleteRequesting ? (
                                    <>
                                      <Spinner size="sm" />
                                      <span className="mb-2">
                                        {" "}
                                        Deleting
                                      </span>{" "}
                                    </>
                                  ) : (
                                    "Yes, delete it!"
                                  )
                                }
                                confirmBtnBsStyle="danger"
                                cancelBtnBsStyle="info"
                              />
                            </Portal>
                          )}

                          <Row>
                            <Col xs="10" md="9">
                              <h5 className="fw-bold mt-3">Emails </h5>
                            </Col>
                            <Col xs="2" md="3" className="mt-3">
                              <Button
                                className=" "
                                color="link"
                                onClick={() => {
                                  setCustom2(!custom2);
                                  setBtn("Add");
                                }}
                              >
                                ADD
                              </Button>
                            </Col>
                          </Row>

                          <Collapse isOpen={custom2}>
                            <div className="mb-3">
                              <Row>
                                <Col md="12" className="mt-2">
                                  <Input
                                    type="email"
                                    value={emailData.email || " "}
                                    valid={
                                      emailValidate.validate === "has-success"
                                    }
                                    invalid={
                                      emailValidate.validate === "has-danger"
                                    }
                                    placeholder="email@exmaple.com"
                                    onChange={(e) =>
                                      handleChange1(e.target.value, "email")
                                    }
                                  />
                                  <Col md="12">
                                    <Input type="select" className="mt-2">
                                      <option>Not Verified</option>
                                      <option>Verified</option>
                                      <option>Verified, Contacted</option>
                                      <option>Do not contact</option>
                                    </Input>
                                  </Col>
                                  <FormFeedback>
                                    Please input a complete correct email.
                                  </FormFeedback>
                                  <FormFeedback valid>
                                    That's a tasty looking email you've got
                                    there.
                                  </FormFeedback>
                                </Col>
                                <Col md="6" className="mt-2">
                                  <Button
                                    block
                                    outline
                                    className=" btn-wide mb-2 me-2 btn-transition"
                                    color="secondary"
                                    onClick={() => emailValueCancel()}
                                  >
                                    Cancel
                                  </Button>
                                </Col>
                                <Col md="6" className="mt-2">
                                  <Button
                                    block
                                    outline
                                    className="btn-wide mb-2 me-2 btn-transition"
                                    color="primary"
                                    onClick={addUpdateEmail}
                                  >
                                    {emailRequesting ? (
                                      <>
                                        <Spinner size="sm" />
                                        <span className="mb-2">
                                          {" "}
                                          {btn}ing
                                        </span>{" "}
                                      </>
                                    ) : (
                                      btn
                                    )}
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          </Collapse>

                          {email?.map((ph, key) => {
                            return (
                              <Row key={key} className="g-0">
                                <Col xs="7">{ph?.email || "none"}</Col>
                                <Col xs="5">
                                  {ph?.user_defined !== 1 ? (
                                    <Button
                                      className="border-0 btn-transition"
                                      outline
                                      color="info"
                                      title="Mail"
                                      onClick={() =>
                                        window.open(`mailto:${ph?.email}`)
                                      }
                                    >
                                      <FontAwesomeIcon
                                        icon={faEnvelope}
                                        size="1x"
                                      />
                                    </Button>
                                  ) : (
                                    <div className="text-danger">
                                      <Button
                                        className="border-0 btn-transition"
                                        outline
                                        color="primary"
                                        onClick={() => {
                                          setCustom2(!custom2);
                                          setBtn("Edit");
                                          setEmailData({
                                            ...state2,
                                            email: ph?.email,
                                            old_email: ph?.email,
                                          });
                                        }}
                                        title=" Edit"
                                      >
                                        <FontAwesomeIcon
                                          icon={faPen}
                                          size="1x"
                                        />
                                      </Button>
                                      <Button
                                        className="border-0 btn-transition"
                                        outline
                                        color="danger"
                                        onClick={() => {
                                          setAlert2(true);
                                          setSpecificEmail(ph?.email);
                                        }}
                                        title=" Delete"
                                      >
                                        <FontAwesomeIcon
                                          icon={faTrashAlt}
                                          size="1x"
                                        />
                                      </Button>
                                      <Button
                                        className="border-0 btn-transition"
                                        outline
                                        color="info"
                                        title=" Mail"
                                        onClick={() =>
                                          window.open(`mailto:${ph?.email}`)
                                        }
                                      >
                                        <FontAwesomeIcon
                                          icon={faEnvelope}
                                          size="1x"
                                        />
                                      </Button>
                                    </div>
                                  )}
                                </Col>
                              </Row>
                            );
                          })}

                          {alert2 && (
                            <Portal id="sweet-alert-portal">
                              <SweetAlert
                                title="Are you sure?"
                                show={alert2}
                                type="danger"
                                onConfirm={deleteEmail}
                                onCancel={() => setAlert2(false)}
                                showCancel
                                confirmBtnText={
                                  deleteRequesting ? (
                                    <>
                                      <Spinner size="sm" />
                                      <span className="mb-2">
                                        {" "}
                                        Deleting
                                      </span>{" "}
                                    </>
                                  ) : (
                                    "Yes, delete it!"
                                  )
                                }
                                confirmBtnBsStyle="danger"
                                cancelBtnBsStyle="info"
                              />
                            </Portal>
                          )}
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                )}
              </Col>
            </Row>
          </div>
        </CSSTransition>
      </TransitionGroup>
    </Fragment>
  );
}
